(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(471);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 7 modules
var lib = __webpack_require__(7878);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(7887);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useSubscription.js
var useSubscription = __webpack_require__(5436);
;// CONCATENATED MODULE: ./src/types/generated/types-orchestration.tsx
/* eslint-disable */ 

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment Question on Question {\n  id\n  definition_id\n  key\n  title\n  dataPointValueType\n  options {\n    id\n    value\n    label\n  }\n  questionType\n  userQuestionType\n  questionConfig {\n    recode_enabled\n    mandatory\n    use_select\n    slider {\n      min\n      max\n      step_value\n      display_marks\n      min_label\n      max_label\n      is_value_tooltip_on\n      show_min_max_values\n    }\n    phone {\n      default_country\n      available_countries\n    }\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment Form on Form {\n  id\n  key\n  title\n  trademark\n  definition_id\n  release_id\n  questions {\n    ...Question\n  }\n}\n    ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment HostedSession on HostedSession {\n  id\n  pathway_id\n  status\n  success_url\n  cancel_url\n  stakeholder {\n    id\n    type\n    name\n  }\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment Activity on Activity {\n  id\n  date\n  status\n  form_display_mode\n  object {\n    id\n    type\n    name\n  }\n  indirect_object {\n    id\n    type\n    name\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetChecklist($id: String!) {\n  checklist(id: $id) {\n    checklist {\n      title\n      items\n    }\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CompleteExtensionActivity($input: CompleteExtensionActivityInput!) {\n  completeExtensionActivity(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation EvaluateFormRules($input: EvaluateFormRulesInput!) {\n  evaluateFormRules(input: $input) {\n    results {\n      question_id\n      rule_id\n      satisfied\n    }\n  }\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetExtensionActivityDetails($id: String!) {\n  extensionActivityRecord(id: $id) {\n    record {\n      id\n      activity_id\n      pathway_id\n      data_points {\n        label\n        value\n      }\n      plugin_key\n      plugin_action_key\n      fields {\n        id\n        type\n        label\n        value\n      }\n      date\n      settings {\n        value\n        label\n        key\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetForm($id: String!) {\n  form(id: $id) {\n    form {\n      ...Form\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetFormResponse($pathway_id: String!, $activity_id: String!) {\n  formResponse(pathway_id: $pathway_id, activity_id: $activity_id) {\n    response {\n      answers {\n        question_id\n        value\n        value_type\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    subscription OnHostedSessionCompleted {\n  sessionCompleted {\n    ...HostedSession\n  }\n}\n    ",
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    subscription OnHostedSessionExpired {\n  sessionExpired {\n    ...HostedSession\n  }\n}\n    ",
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetHostedSession {\n  hostedSession {\n    session {\n      ...HostedSession\n    }\n    branding {\n      logo_url\n      hosted_page_title\n      accent_color\n      hosted_page_auto_progress\n      hosted_page_autosave\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMessage($id: String!) {\n  message(id: $id) {\n    message {\n      id\n      body\n      subject\n      format\n      attachments {\n        id\n        name\n        type\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation MarkMessageAsRead($input: MarkMessageAsReadInput!) {\n  markMessageAsRead(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetHostedSessionActivities($only_stakeholder_activities: Boolean) {\n  hostedSessionActivities(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    success\n    activities {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    subscription OnSessionActivityCompleted($only_stakeholder_activities: Boolean!) {\n  sessionActivityCompleted(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    subscription OnSessionActivityCreated($only_stakeholder_activities: Boolean!) {\n  sessionActivityCreated(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    subscription OnSessionActivityExpired($only_stakeholder_activities: Boolean!) {\n  sessionActivityExpired(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    subscription OnSessionActivityUpdated($only_stakeholder_activities: Boolean!) {\n  sessionActivityUpdated(\n    only_stakeholder_activities: $only_stakeholder_activities\n  ) {\n    ...Activity\n  }\n}\n    ",
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SubmitChecklist($input: SubmitChecklistInput!) {\n  submitChecklist(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SubmitFormResponse($input: SubmitFormResponseInput!) {\n  submitFormResponse(input: $input) {\n    activity {\n      ...Activity\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var result = {
    "possibleTypes": {
        "Payload": [
            "ActionPayload",
            "ActivitiesPayload",
            "AddTrackPayload",
            "ApiCallPayload",
            "ApiCallsPayload",
            "BaselineInfoPayload",
            "CalculationResultsPayload",
            "CancelScheduledTracksPayload",
            "ChecklistPayload",
            "ClinicalNotePayload",
            "CompleteExtensionActivityPayload",
            "CreatePatientPayload",
            "ElementsPayload",
            "EmptyPayload",
            "EmrReportPayload",
            "EvaluateFormRulesPayload",
            "ExtensionActivityRecordPayload",
            "FormPayload",
            "FormResponsePayload",
            "FormsPayload",
            "HostedSessionActivitiesPayload",
            "HostedSessionPayload",
            "MarkMessageAsReadPayload",
            "MessagePayload",
            "OrchestrationFactsPayload",
            "OrchestrationFactsPromptPayload",
            "PathwayDataPointDefinitionsPayload",
            "PathwayPayload",
            "PathwaysPayload",
            "PatientDemographicsPayload",
            "PatientPathwaysPayload",
            "PatientPayload",
            "PatientsPayload",
            "PublishedPathwayDefinitionsPayload",
            "RetryApiCallPayload",
            "RetryWebhookCallPayload",
            "ScheduleTrackPayload",
            "ScheduledStepsPayload",
            "ScheduledTracksPayload",
            "SearchPatientsPayload",
            "StakeholdersPayload",
            "StartHostedActivitySessionPayload",
            "StartHostedPathwaySessionFromLinkPayload",
            "StartHostedPathwaySessionPayload",
            "StartPathwayPayload",
            "StopTrackPayload",
            "SubmitChecklistPayload",
            "SubmitFormResponsePayload",
            "TracksPayload",
            "UpdatePatientDemographicsQueryPayload",
            "UpdatePatientLanguagePayload",
            "UpdatePatientPayload",
            "UserPayload",
            "WebhookCallPayload",
            "WebhookCallsPayload"
        ]
    }
};
/* harmony default export */ var types_orchestration = ((/* unused pure expression or super */ null && (result)));
var ActionType;
(function(ActionType) {
    ActionType["ApiCall"] = "API_CALL";
    ActionType["ApiCallGraphql"] = "API_CALL_GRAPHQL";
    ActionType["Calculation"] = "CALCULATION";
    ActionType["Checklist"] = "CHECKLIST";
    ActionType["ClinicalNote"] = "CLINICAL_NOTE";
    ActionType["Form"] = "FORM";
    ActionType["Message"] = "MESSAGE";
    ActionType["Plugin"] = "PLUGIN";
    ActionType["PushToEmr"] = "PUSH_TO_EMR";
})(ActionType || (ActionType = {}));
var ActivityAction;
(function(ActivityAction) {
    ActivityAction["Activate"] = "ACTIVATE";
    ActivityAction["Added"] = "ADDED";
    ActivityAction["Assigned"] = "ASSIGNED";
    ActivityAction["Complete"] = "COMPLETE";
    ActivityAction["Computed"] = "COMPUTED";
    ActivityAction["Delegated"] = "DELEGATED";
    ActivityAction["Deliver"] = "DELIVER";
    ActivityAction["Discarded"] = "DISCARDED";
    ActivityAction["Expired"] = "EXPIRED";
    ActivityAction["Failed"] = "FAILED";
    ActivityAction["FailedToSend"] = "FAILED_TO_SEND";
    ActivityAction["Generated"] = "GENERATED";
    ActivityAction["IsWaitingOn"] = "IS_WAITING_ON";
    ActivityAction["Postponed"] = "POSTPONED";
    ActivityAction["Processed"] = "PROCESSED";
    ActivityAction["Read"] = "READ";
    ActivityAction["Remind"] = "REMIND";
    ActivityAction["Reported"] = "REPORTED";
    ActivityAction["Scheduled"] = "SCHEDULED";
    ActivityAction["Send"] = "SEND";
    ActivityAction["Skipped"] = "SKIPPED";
    ActivityAction["Stopped"] = "STOPPED";
    ActivityAction["Submitted"] = "SUBMITTED";
})(ActivityAction || (ActivityAction = {}));
var ActivityObjectType;
(function(ActivityObjectType) {
    ActivityObjectType["Action"] = "ACTION";
    ActivityObjectType["ApiCall"] = "API_CALL";
    ActivityObjectType["Calculation"] = "CALCULATION";
    ActivityObjectType["Checklist"] = "CHECKLIST";
    ActivityObjectType["ClinicalNote"] = "CLINICAL_NOTE";
    ActivityObjectType["EmrReport"] = "EMR_REPORT";
    ActivityObjectType["EmrRequest"] = "EMR_REQUEST";
    ActivityObjectType["EvaluatedRule"] = "EVALUATED_RULE";
    ActivityObjectType["Form"] = "FORM";
    ActivityObjectType["Message"] = "MESSAGE";
    ActivityObjectType["Pathway"] = "PATHWAY";
    ActivityObjectType["Patient"] = "PATIENT";
    ActivityObjectType["Plugin"] = "PLUGIN";
    ActivityObjectType["PluginAction"] = "PLUGIN_ACTION";
    ActivityObjectType["Reminder"] = "REMINDER";
    ActivityObjectType["Stakeholder"] = "STAKEHOLDER";
    ActivityObjectType["Step"] = "STEP";
    ActivityObjectType["Track"] = "TRACK";
    ActivityObjectType["User"] = "USER";
})(ActivityObjectType || (ActivityObjectType = {}));
var ActivityResolution;
(function(ActivityResolution) {
    ActivityResolution["Expired"] = "EXPIRED";
    ActivityResolution["Failure"] = "FAILURE";
    ActivityResolution["Success"] = "SUCCESS";
})(ActivityResolution || (ActivityResolution = {}));
var ActivityStatus;
(function(ActivityStatus) {
    ActivityStatus["Active"] = "ACTIVE";
    ActivityStatus["Canceled"] = "CANCELED";
    ActivityStatus["Done"] = "DONE";
    ActivityStatus["Expired"] = "EXPIRED";
    ActivityStatus["Failed"] = "FAILED";
})(ActivityStatus || (ActivityStatus = {}));
var ActivitySubjectType;
(function(ActivitySubjectType) {
    ActivitySubjectType["ApiCall"] = "API_CALL";
    ActivitySubjectType["Awell"] = "AWELL";
    ActivitySubjectType["Plugin"] = "PLUGIN";
    ActivitySubjectType["Stakeholder"] = "STAKEHOLDER";
    ActivitySubjectType["User"] = "USER";
})(ActivitySubjectType || (ActivitySubjectType = {}));
var ApiCallRequestMethod;
(function(ApiCallRequestMethod) {
    ApiCallRequestMethod["Get"] = "GET";
    ApiCallRequestMethod["Post"] = "POST";
})(ApiCallRequestMethod || (ApiCallRequestMethod = {}));
var ApiCallStatus;
(function(ApiCallStatus) {
    ApiCallStatus["Failed"] = "Failed";
    ApiCallStatus["InProgress"] = "InProgress";
    ApiCallStatus["Pending"] = "Pending";
    ApiCallStatus["PermanentlyFailed"] = "PermanentlyFailed";
    ApiCallStatus["Skipped"] = "Skipped";
    ApiCallStatus["Success"] = "Success";
})(ApiCallStatus || (ApiCallStatus = {}));
var BooleanOperator;
(function(BooleanOperator) {
    BooleanOperator["And"] = "AND";
    BooleanOperator["Or"] = "OR";
})(BooleanOperator || (BooleanOperator = {}));
var ConditionOperandType;
(function(ConditionOperandType) {
    ConditionOperandType["Boolean"] = "BOOLEAN";
    ConditionOperandType["DataPoint"] = "DATA_POINT";
    ConditionOperandType["DataSource"] = "DATA_SOURCE";
    ConditionOperandType["Number"] = "NUMBER";
    ConditionOperandType["NumbersArray"] = "NUMBERS_ARRAY";
    ConditionOperandType["String"] = "STRING";
})(ConditionOperandType || (ConditionOperandType = {}));
var ConditionOperator;
(function(ConditionOperator) {
    ConditionOperator["Contains"] = "CONTAINS";
    ConditionOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    ConditionOperator["IsAnyOf"] = "IS_ANY_OF";
    ConditionOperator["IsEmpty"] = "IS_EMPTY";
    ConditionOperator["IsEqualTo"] = "IS_EQUAL_TO";
    ConditionOperator["IsGreaterThan"] = "IS_GREATER_THAN";
    ConditionOperator["IsGreaterThanOrEqualTo"] = "IS_GREATER_THAN_OR_EQUAL_TO";
    ConditionOperator["IsInRange"] = "IS_IN_RANGE";
    ConditionOperator["IsLessThan"] = "IS_LESS_THAN";
    ConditionOperator["IsLessThanOrEqualTo"] = "IS_LESS_THAN_OR_EQUAL_TO";
    ConditionOperator["IsNoneOf"] = "IS_NONE_OF";
    ConditionOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
    ConditionOperator["IsNotEqualTo"] = "IS_NOT_EQUAL_TO";
    ConditionOperator["IsNotTrue"] = "IS_NOT_TRUE";
    ConditionOperator["IsToday"] = "IS_TODAY";
    ConditionOperator["IsTrue"] = "IS_TRUE";
})(ConditionOperator || (ConditionOperator = {}));
var DataPointSourceType;
(function(DataPointSourceType) {
    DataPointSourceType["ApiCall"] = "API_CALL";
    DataPointSourceType["ApiCallStatus"] = "API_CALL_STATUS";
    DataPointSourceType["Calculation"] = "CALCULATION";
    DataPointSourceType["ExtensionAction"] = "EXTENSION_ACTION";
    DataPointSourceType["ExtensionWebhook"] = "EXTENSION_WEBHOOK";
    DataPointSourceType["Form"] = "FORM";
    DataPointSourceType["Pathway"] = "PATHWAY";
    DataPointSourceType["PatientProfile"] = "PATIENT_PROFILE";
    DataPointSourceType["Step"] = "STEP";
    DataPointSourceType["Track"] = "TRACK";
})(DataPointSourceType || (DataPointSourceType = {}));
var DataPointValueType;
(function(DataPointValueType) {
    DataPointValueType["Boolean"] = "BOOLEAN";
    DataPointValueType["Date"] = "DATE";
    DataPointValueType["Number"] = "NUMBER";
    DataPointValueType["NumbersArray"] = "NUMBERS_ARRAY";
    DataPointValueType["String"] = "STRING";
    DataPointValueType["Telephone"] = "TELEPHONE";
})(DataPointValueType || (DataPointValueType = {}));
var ElementStatus;
(function(ElementStatus) {
    ElementStatus["Active"] = "ACTIVE";
    ElementStatus["Discarded"] = "DISCARDED";
    ElementStatus["Done"] = "DONE";
    ElementStatus["Postponed"] = "POSTPONED";
    ElementStatus["Scheduled"] = "SCHEDULED";
    ElementStatus["Stopped"] = "STOPPED";
})(ElementStatus || (ElementStatus = {}));
var ElementType;
(function(ElementType) {
    ElementType["Action"] = "ACTION";
    ElementType["Pathway"] = "PATHWAY";
    ElementType["Step"] = "STEP";
    ElementType["Track"] = "TRACK";
    ElementType["Trigger"] = "TRIGGER";
})(ElementType || (ElementType = {}));
var ExtensionActionFieldType;
(function(ExtensionActionFieldType) {
    ExtensionActionFieldType["Boolean"] = "BOOLEAN";
    ExtensionActionFieldType["Date"] = "DATE";
    ExtensionActionFieldType["Html"] = "HTML";
    ExtensionActionFieldType["Json"] = "JSON";
    ExtensionActionFieldType["Numeric"] = "NUMERIC";
    ExtensionActionFieldType["String"] = "STRING";
    ExtensionActionFieldType["Text"] = "TEXT";
})(ExtensionActionFieldType || (ExtensionActionFieldType = {}));
var FormDisplayMode;
(function(FormDisplayMode) {
    FormDisplayMode["Conversational"] = "CONVERSATIONAL";
    FormDisplayMode["Regular"] = "REGULAR";
})(FormDisplayMode || (FormDisplayMode = {}));
var HostedSessionStakeholderType;
(function(HostedSessionStakeholderType) {
    HostedSessionStakeholderType["Patient"] = "PATIENT";
    HostedSessionStakeholderType["Stakeholder"] = "STAKEHOLDER";
})(HostedSessionStakeholderType || (HostedSessionStakeholderType = {}));
var HostedSessionStatus;
(function(HostedSessionStatus) {
    HostedSessionStatus["Active"] = "ACTIVE";
    HostedSessionStatus["Completed"] = "COMPLETED";
    HostedSessionStatus["Expired"] = "EXPIRED";
})(HostedSessionStatus || (HostedSessionStatus = {}));
var MessageAttachmentType;
(function(MessageAttachmentType) {
    MessageAttachmentType["File"] = "FILE";
    MessageAttachmentType["Link"] = "LINK";
    MessageAttachmentType["Video"] = "VIDEO";
})(MessageAttachmentType || (MessageAttachmentType = {}));
var MessageFormat;
(function(MessageFormat) {
    MessageFormat["Html"] = "HTML";
    MessageFormat["Slate"] = "SLATE";
})(MessageFormat || (MessageFormat = {}));
var PathwayStatus;
(function(PathwayStatus) {
    PathwayStatus["Active"] = "active";
    PathwayStatus["Completed"] = "completed";
    PathwayStatus["MissingBaselineInfo"] = "missing_baseline_info";
    PathwayStatus["Starting"] = "starting";
    PathwayStatus["Stopped"] = "stopped";
})(PathwayStatus || (PathwayStatus = {}));
var QuestionType;
(function(QuestionType) {
    QuestionType["Input"] = "INPUT";
    QuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    QuestionType["NoInput"] = "NO_INPUT";
})(QuestionType || (QuestionType = {}));
var Sex;
(function(Sex) {
    Sex["Female"] = "FEMALE";
    Sex["Male"] = "MALE";
    Sex["NotKnown"] = "NOT_KNOWN";
})(Sex || (Sex = {}));
var StakeholderClinicalAppRole;
(function(StakeholderClinicalAppRole) {
    StakeholderClinicalAppRole["Caregiver"] = "CAREGIVER";
    StakeholderClinicalAppRole["Patient"] = "PATIENT";
    StakeholderClinicalAppRole["Physician"] = "PHYSICIAN";
})(StakeholderClinicalAppRole || (StakeholderClinicalAppRole = {}));
var SwimlaneItemCategory;
(function(SwimlaneItemCategory) {
    SwimlaneItemCategory["Action"] = "ACTION";
    SwimlaneItemCategory["PathwayEnd"] = "PATHWAY_END";
    SwimlaneItemCategory["PathwayStart"] = "PATHWAY_START";
    SwimlaneItemCategory["Step"] = "STEP";
    SwimlaneItemCategory["Track"] = "TRACK";
    SwimlaneItemCategory["TrackEnd"] = "TRACK_END";
    SwimlaneItemCategory["TrackStart"] = "TRACK_START";
})(SwimlaneItemCategory || (SwimlaneItemCategory = {}));
var SwimlaneItemType;
(function(SwimlaneItemType) {
    SwimlaneItemType["Active"] = "active";
    SwimlaneItemType["Completed"] = "completed";
    SwimlaneItemType["Pending"] = "pending";
    SwimlaneItemType["Possible"] = "possible";
})(SwimlaneItemType || (SwimlaneItemType = {}));
var UserQuestionType;
(function(UserQuestionType) {
    UserQuestionType["Date"] = "DATE";
    UserQuestionType["Description"] = "DESCRIPTION";
    UserQuestionType["LongText"] = "LONG_TEXT";
    UserQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    UserQuestionType["MultipleChoiceGrid"] = "MULTIPLE_CHOICE_GRID";
    UserQuestionType["MultipleSelect"] = "MULTIPLE_SELECT";
    UserQuestionType["Number"] = "NUMBER";
    UserQuestionType["ShortText"] = "SHORT_TEXT";
    UserQuestionType["Signature"] = "SIGNATURE";
    UserQuestionType["Slider"] = "SLIDER";
    UserQuestionType["Telephone"] = "TELEPHONE";
    UserQuestionType["YesNo"] = "YES_NO";
})(UserQuestionType || (UserQuestionType = {}));
var QuestionFragmentDoc = (0,lib/* gql */.Ps)(_templateObject());
var FormFragmentDoc = (0,lib/* gql */.Ps)(_templateObject1(), QuestionFragmentDoc);
var HostedSessionFragmentDoc = (0,lib/* gql */.Ps)(_templateObject2());
var ActivityFragmentDoc = (0,lib/* gql */.Ps)(_templateObject3());
var GetChecklistDocument = (0,lib/* gql */.Ps)(_templateObject4());
/**
 * __useGetChecklistQuery__
 *
 * To run a query within a React component, call `useGetChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetChecklistQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetChecklistDocument, options);
}
function useGetChecklistLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetChecklistDocument, options);
}
var CompleteExtensionActivityDocument = (0,lib/* gql */.Ps)(_templateObject5(), ActivityFragmentDoc);
/**
 * __useCompleteExtensionActivityMutation__
 *
 * To run a mutation, you first call `useCompleteExtensionActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteExtensionActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeExtensionActivityMutation, { data, loading, error }] = useCompleteExtensionActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCompleteExtensionActivityMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(CompleteExtensionActivityDocument, options);
}
var EvaluateFormRulesDocument = (0,lib/* gql */.Ps)(_templateObject6());
/**
 * __useEvaluateFormRulesMutation__
 *
 * To run a mutation, you first call `useEvaluateFormRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateFormRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateFormRulesMutation, { data, loading, error }] = useEvaluateFormRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useEvaluateFormRulesMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(EvaluateFormRulesDocument, options);
}
var GetExtensionActivityDetailsDocument = (0,lib/* gql */.Ps)(_templateObject7());
/**
 * __useGetExtensionActivityDetailsQuery__
 *
 * To run a query within a React component, call `useGetExtensionActivityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionActivityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionActivityDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetExtensionActivityDetailsQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetExtensionActivityDetailsDocument, options);
}
function useGetExtensionActivityDetailsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetExtensionActivityDetailsDocument, options);
}
var GetFormDocument = (0,lib/* gql */.Ps)(_templateObject8(), FormFragmentDoc);
/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetFormQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetFormDocument, options);
}
function useGetFormLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFormDocument, options);
}
var GetFormResponseDocument = (0,lib/* gql */.Ps)(_templateObject9());
/**
 * __useGetFormResponseQuery__
 *
 * To run a query within a React component, call `useGetFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseQuery({
 *   variables: {
 *      pathway_id: // value for 'pathway_id'
 *      activity_id: // value for 'activity_id'
 *   },
 * });
 */ function useGetFormResponseQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetFormResponseDocument, options);
}
function useGetFormResponseLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFormResponseDocument, options);
}
var OnHostedSessionCompletedDocument = (0,lib/* gql */.Ps)(_templateObject10(), HostedSessionFragmentDoc);
/**
 * __useOnHostedSessionCompletedSubscription__
 *
 * To run a query within a React component, call `useOnHostedSessionCompletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnHostedSessionCompletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnHostedSessionCompletedSubscription({
 *   variables: {
 *   },
 * });
 */ function useOnHostedSessionCompletedSubscription(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useSubscription/* useSubscription */.m(OnHostedSessionCompletedDocument, options);
}
var OnHostedSessionExpiredDocument = (0,lib/* gql */.Ps)(_templateObject11(), HostedSessionFragmentDoc);
/**
 * __useOnHostedSessionExpiredSubscription__
 *
 * To run a query within a React component, call `useOnHostedSessionExpiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnHostedSessionExpiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnHostedSessionExpiredSubscription({
 *   variables: {
 *   },
 * });
 */ function useOnHostedSessionExpiredSubscription(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useSubscription/* useSubscription */.m(OnHostedSessionExpiredDocument, options);
}
var GetHostedSessionDocument = (0,lib/* gql */.Ps)(_templateObject12(), HostedSessionFragmentDoc);
/**
 * __useGetHostedSessionQuery__
 *
 * To run a query within a React component, call `useGetHostedSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedSessionQuery({
 *   variables: {
 *   },
 * });
 */ function useGetHostedSessionQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetHostedSessionDocument, options);
}
function useGetHostedSessionLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetHostedSessionDocument, options);
}
var GetMessageDocument = (0,lib/* gql */.Ps)(_templateObject13());
/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetMessageQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetMessageDocument, options);
}
function useGetMessageLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetMessageDocument, options);
}
var MarkMessageAsReadDocument = (0,lib/* gql */.Ps)(_templateObject14(), ActivityFragmentDoc);
/**
 * __useMarkMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageAsReadMutation, { data, loading, error }] = useMarkMessageAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useMarkMessageAsReadMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(MarkMessageAsReadDocument, options);
}
var GetHostedSessionActivitiesDocument = (0,lib/* gql */.Ps)(_templateObject15(), ActivityFragmentDoc);
/**
 * __useGetHostedSessionActivitiesQuery__
 *
 * To run a query within a React component, call `useGetHostedSessionActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedSessionActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedSessionActivitiesQuery({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useGetHostedSessionActivitiesQuery(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useQuery/* useQuery */.a(GetHostedSessionActivitiesDocument, options);
}
function useGetHostedSessionActivitiesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetHostedSessionActivitiesDocument, options);
}
var OnSessionActivityCompletedDocument = (0,lib/* gql */.Ps)(_templateObject16(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityCompletedSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityCompletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityCompletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityCompletedSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityCompletedSubscription(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useSubscription/* useSubscription */.m(OnSessionActivityCompletedDocument, options);
}
var OnSessionActivityCreatedDocument = (0,lib/* gql */.Ps)(_templateObject17(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityCreatedSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityCreatedSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityCreatedSubscription(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useSubscription/* useSubscription */.m(OnSessionActivityCreatedDocument, options);
}
var OnSessionActivityExpiredDocument = (0,lib/* gql */.Ps)(_templateObject18(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityExpiredSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityExpiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityExpiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityExpiredSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityExpiredSubscription(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useSubscription/* useSubscription */.m(OnSessionActivityExpiredDocument, options);
}
var OnSessionActivityUpdatedDocument = (0,lib/* gql */.Ps)(_templateObject19(), ActivityFragmentDoc);
/**
 * __useOnSessionActivityUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnSessionActivityUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionActivityUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionActivityUpdatedSubscription({
 *   variables: {
 *      only_stakeholder_activities: // value for 'only_stakeholder_activities'
 *   },
 * });
 */ function useOnSessionActivityUpdatedSubscription(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useSubscription(OnSessionActivityUpdatedDocument, options);
}
var SubmitChecklistDocument = (0,lib/* gql */.Ps)(_templateObject20(), ActivityFragmentDoc);
/**
 * __useSubmitChecklistMutation__
 *
 * To run a mutation, you first call `useSubmitChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChecklistMutation, { data, loading, error }] = useSubmitChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useSubmitChecklistMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(SubmitChecklistDocument, options);
}
var SubmitFormResponseDocument = (0,lib/* gql */.Ps)(_templateObject21(), ActivityFragmentDoc);
/**
 * __useSubmitFormResponseMutation__
 *
 * To run a mutation, you first call `useSubmitFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResponseMutation, { data, loading, error }] = useSubmitFormResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useSubmitFormResponseMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(SubmitFormResponseDocument, options);
}

;// CONCATENATED MODULE: ./src/hooks/useHostedSession/types.ts


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(6252);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js + 14 modules
var createHttpLink = __webpack_require__(5465);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(6909);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/split.js
var split = __webpack_require__(5367);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 13 modules
var ApolloClient = __webpack_require__(1954);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 8 modules
var inMemoryCache = __webpack_require__(6118);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/graphql-ws/lib/client.mjs + 2 modules
var client = __webpack_require__(2037);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/subscriptions/index.js
var subscriptions = __webpack_require__(5210);
;// CONCATENATED MODULE: ./src/services/graphql/apollo-client.ts







var createClient = function(param) {
    var httpUri = param.httpUri, wsUri = param.wsUri, _onNetworkError = param.onNetworkError, onNetworkError = _onNetworkError === void 0 ? function() {
        return undefined;
    } : _onNetworkError, _extraLinks = param.extraLinks, extraLinks = _extraLinks === void 0 ? [] : _extraLinks, cacheConfig = param.cacheConfig;
    var httpLink = (0,createHttpLink/* createHttpLink */.L)({
        uri: httpUri
    });
    var errorHandlingLink = (0,error/* onError */.q)(function(response) {
        if (response.networkError) {
            onNetworkError(response);
        }
    });
    var authenticationLink = new ApolloLink/* ApolloLink */.i(function(operation, forward) {
        // why do we need to use sessionStorage here? Can we not pass the token in to this
        // function from the GraphqlWrapper component?
        var accessToken = sessionStorage.getItem("accessToken");
        operation.setContext({
            headers: {
                authorization: accessToken ? "Bearer ".concat(accessToken) : ""
            }
        });
        return forward(operation);
    });
    var createWsLink = function() {
        if ((0,lodash.isNil)(window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("accessToken"))) {
            return null;
        }
        if ((window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("TEST_DISABLE_SUBSCRIPTIONS")) === "true") {
            console.info("Disabling GraphQL subscriptions for testing purposes");
            return null;
        }
        return new subscriptions/* GraphQLWsLink */.g((0,client/* createClient */.eI)({
            url: wsUri,
            connectionParams: {
                authToken: window.sessionStorage.getItem("accessToken")
            }
        }));
    };
    var wsLink = createWsLink();
    var isSubscription = function(param) {
        var query = param.query;
        var definition = (0,getFromAST/* getMainDefinition */.p$)(query);
        return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    };
    var defaultLink = ApolloLink/* ApolloLink.from */.i.from([
        authenticationLink, 
    ].concat((0,_to_consumable_array/* default */.Z)(extraLinks), [
        errorHandlingLink,
        httpLink, 
    ]));
    var link = wsLink ? (0,split/* split */.V)(isSubscription, wsLink, defaultLink) : defaultLink;
    return new ApolloClient/* ApolloClient */.f({
        ssrMode: "object" === "undefined",
        connectToDevTools: "production" !== "production",
        cache: new inMemoryCache/* InMemoryCache */.h(cacheConfig),
        link: link,
        credentials: "include"
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./src/services/graphql/createApolloCacheUpdate.ts


var createApolloCacheUpdate = function(param) {
    var query = param.query, variables = param.variables, updateFunction = param.updateFunction;
    var update = function(cache, result) {
        var cachedQuery = cache.readQuery({
            query: query,
            variables: variables
        });
        var updatedCachedQuery = updateFunction({
            result: result,
            query: cachedQuery
        });
        cache.writeQuery({
            query: query,
            variables: variables,
            data: updatedCachedQuery
        });
    };
    return update;
};
/**
 * Convenience function to update a query without having to manually
 * copy the query object and put the new value in the right place.
 * Why not use lodash or ramda directly ? Typing lenses in ramda
 * is a pain in the arse, and lodash doesn't have a typed function
 * that can updated a nested property.
 * This function has the benefit of being typed: the path is automatically
 * infered and validated by typescript depending on the query type.
 * The value type isn't inferred though so it still needs to be explicitly
 * defined by the calling code.
 */ var updateQuery = function(query, path, value) {
    var propertyPath = path;
    // Build an object that can be used with assign to update the query.
    // Example:
    // ```
    // const path = ['some', 'nested', 'property']
    // const value = ['a', 'list', 'of', 'values']
    // const updateObj = {
    //   some: {
    //     nested: {
    //       property: ['a', 'list', 'of', 'values']
    //     }
    //   }
    // }
    var updateObj = propertyPath.reverse().reduce(function(agg, currentProperty) {
        return (0,_define_property/* default */.Z)({}, currentProperty, agg);
    }, value);
    // By default lodash merges array, which makes it impossible
    // to remove array items. This customiser overrides that behaviour
    // to use only the source value when it is an array.
    // See https://lodash.com/docs/4.17.15#mergeWith
    var replaceArray = function(objValue, srcValue) {
        if (Array.isArray(srcValue)) {
            return srcValue;
        }
        return undefined;
    };
    return (0,lodash.mergeWith)({}, query, updateObj, replaceArray);
};

;// CONCATENATED MODULE: ./src/services/graphql/index.ts



// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
;// CONCATENATED MODULE: ./src/hooks/useHostedSession/useHostedSession.ts
/* eslint-disable react-hooks/exhaustive-deps */ 






var POLLING_DELAY_MS = 2000;
var useHostedSession = function() {
    var ref, ref1;
    var ref2 = useGetHostedSessionQuery({
        pollInterval: POLLING_DELAY_MS,
        onError: function(error) {
            esm_exports/* captureException */.Tb(error, {
                contexts: {
                    graphql: {
                        query: "GetHostedSession"
                    }
                }
            });
        }
    }), data = ref2.data, loading = ref2.loading, error = ref2.error, refetch = ref2.refetch;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var router = (0,next_router.useRouter)();
    var onHostedSessionCompleted = useOnHostedSessionCompletedSubscription();
    var onHostedSessionExpired = useOnHostedSessionExpiredSubscription();
    var updateHostedSessionQuery = function(param) {
        var updatedHostedSession = param.updatedHostedSession;
        var updatedQuery = updateQuery(data, [
            "hostedSession",
            "session"
        ], updatedHostedSession);
        client.writeQuery({
            query: GetHostedSessionDocument,
            data: updatedQuery
        });
    };
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(router)) {
            esm_exports/* setTags */.mG({
                session: router.query.sessionId,
                api_endpoint: "https://api.development.awellhealth.com/orchestration/graphql"
            });
        }
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!(0,lodash.isNil)(data === null || data === void 0 ? void 0 : (ref = data.hostedSession) === null || ref === void 0 ? void 0 : ref.session)) {
            var hostedSession = data === null || data === void 0 ? void 0 : data.hostedSession.session;
            esm_exports/* setTags */.mG({
                pathway: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.pathway_id,
                stakeholder: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.id
            });
            esm_exports/* setContext */.v("session", {
                id: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.id,
                pathway_id: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.pathway_id,
                success_url: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.success_url,
                cancel_url: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.cancel_url
            });
            esm_exports/* setContext */.v("stakeholder", {
                id: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.id,
                name: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.name,
                type: hostedSession === null || hostedSession === void 0 ? void 0 : hostedSession.stakeholder.type
            });
            esm_exports/* setExtras */.rJ({
                hostedSession: hostedSession,
                branding: data === null || data === void 0 ? void 0 : data.hostedSession.branding
            });
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(onHostedSessionCompleted.data)) {
            var sessionCompleted = onHostedSessionCompleted.data.sessionCompleted;
            updateHostedSessionQuery({
                updatedHostedSession: sessionCompleted
            });
        }
    }, [
        client,
        onHostedSessionCompleted.data
    ]);
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(onHostedSessionExpired.data)) {
            var sessionExpired = onHostedSessionExpired.data.sessionExpired;
            updateHostedSessionQuery({
                updatedHostedSession: sessionExpired
            });
        }
    }, [
        client,
        onHostedSessionExpired.data
    ]);
    if (loading) {
        return {
            loading: true
        };
    }
    if (error) {
        return {
            loading: false,
            error: error.message,
            refetch: refetch
        };
    }
    return {
        loading: false,
        session: data === null || data === void 0 ? void 0 : (ref = data.hostedSession) === null || ref === void 0 ? void 0 : ref.session,
        branding: data === null || data === void 0 ? void 0 : (ref1 = data.hostedSession) === null || ref1 === void 0 ? void 0 : ref1.branding,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useHostedSession/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@awell-health/ui-library/dist/index.js
var dist = __webpack_require__(3066);
;// CONCATENATED MODULE: ./src/hooks/useForm/types.ts


;// CONCATENATED MODULE: ./src/hooks/useForm/useForm.ts





var useForm = function(activity) {
    var ref;
    var variables = {
        id: activity.object.id
    };
    var ref1 = useGetFormQuery({
        variables: variables
    }), formData = ref1.data, loading = ref1.loading, error = ref1.error, refetch = ref1.refetch;
    var t = (0,esm/* useTranslation */.$G)().t;
    if (loading) {
        return {
            loading: true
        };
    }
    if (error || (0,lodash.isNil)(formData === null || formData === void 0 ? void 0 : (ref = formData.form) === null || ref === void 0 ? void 0 : ref.form)) {
        var message = (error === null || error === void 0 ? void 0 : error.message) || t("activities.form.loading_error");
        var populatedError = error || new Error("Error fetching form");
        (0,esm_exports/* captureException */.Tb)(populatedError, {
            contexts: {
                form: {
                    form_id: activity.object.id
                },
                activity: (0,src_object_spread/* default */.Z)({}, activity),
                graphql: {
                    query: "GetForm",
                    variables: JSON.stringify(variables)
                }
            }
        });
        return {
            loading: false,
            error: message,
            refetch: refetch
        };
    }
    return {
        loading: false,
        form: formData === null || formData === void 0 ? void 0 : formData.form.form,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useForm/index.ts


;// CONCATENATED MODULE: ./src/hooks/useEvaluateFormRules/types.ts


;// CONCATENATED MODULE: ./src/hooks/useEvaluateFormRules/useEvaluateFormRules.ts






var useEvaluateFormRules = function(form_id) {
    var ref = (0,_sliced_to_array/* default */.Z)(useEvaluateFormRulesMutation(), 1), evaluateFormRules = ref[0];
    return [
        function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(answers) {
                var variables, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            variables = {
                                input: {
                                    form_id: form_id,
                                    answers: answers
                                }
                            };
                            _ctx.next = 4;
                            return evaluateFormRules({
                                variables: variables,
                                onError: function(error) {
                                    (0,esm_exports/* captureException */.Tb)(error, {
                                        contexts: {
                                            form: {
                                                form_id: form_id
                                            },
                                            answers: (0,src_object_spread/* default */.Z)({}, answers),
                                            graphql: {
                                                query: "EvaluateFormRules",
                                                variables: JSON.stringify(variables)
                                            }
                                        }
                                    });
                                }
                            });
                        case 4:
                            data = _ctx.sent.data;
                            if (data) {
                                _ctx.next = 7;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 7:
                            return _ctx.abrupt("return", data.evaluateFormRules.results);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                            return _ctx.abrupt("return", []);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function(answers) {
                return _ref.apply(this, arguments);
            };
        }(), 
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useEvaluateFormRules/index.ts


;// CONCATENATED MODULE: ./src/components/Form/types.ts


// EXTERNAL MODULE: ./src/components/LoadingPage/index.ts + 1 modules
var LoadingPage = __webpack_require__(6557);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/types.ts


;// CONCATENATED MODULE: ./src/components/Activities/context/ActivityContext.ts

var initialContext = {
    currentActivity: undefined,
    waitingForNewActivities: true,
    unsetCurrentActivity: function() {}
};
var ActivityContext = (0,react.createContext)(initialContext);

;// CONCATENATED MODULE: ./src/components/Activities/types.ts


;// CONCATENATED MODULE: ./src/hooks/useSessionActivities/types.ts


;// CONCATENATED MODULE: ./src/hooks/useSessionActivities/useSessionActivities.ts
/* eslint-disable react-hooks/exhaustive-deps */ 






var POLLING_DELAY = 5000 // 5 seconds
;
var useSessionActivities = function() {
    var variables = {
        only_stakeholder_activities: true
    };
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref = useGetHostedSessionActivitiesQuery({
        variables: variables,
        pollInterval: POLLING_DELAY,
        onError: function(error) {
            (0,esm_exports/* captureException */.Tb)(error, {
                contexts: {
                    graphql: {
                        query: "GetHostedSessionActivities",
                        variables: JSON.stringify(variables)
                    }
                }
            });
        }
    }), data = ref.data, error = ref.error, loading = ref.loading, refetch = ref.refetch;
    var onActivityCreated = useOnSessionActivityCreatedSubscription({
        variables: variables
    });
    /**
   * Why use these subscriptions if we don't do anything with the data ?
   * Because the apollo cache already does the job for us. Any activity that is
   * returned via these subscriptions will automatically be updated in the cache,
   * which means the `activities` array will also be automatically updated.
   */ useOnSessionActivityCompletedSubscription({
        variables: variables
    });
    useOnSessionActivityExpiredSubscription({
        variables: variables
    });
    var sortActivitiesByDate = function(activities) {
        if ((0,lodash.isNil)(activities) || (0,lodash.isEmpty)(activities)) {
            return [];
        }
        return (0,lodash.sortBy)(activities, function(activity) {
            return new Date(activity.date);
        });
    };
    var ref1;
    var activities = (ref1 = sortActivitiesByDate(data === null || data === void 0 ? void 0 : data.hostedSessionActivities.activities)) !== null && ref1 !== void 0 ? ref1 : [];
    (0,react.useEffect)(function() {
        if (!(0,lodash.isNil)(onActivityCreated.data)) {
            var sessionActivityCreated = onActivityCreated.data.sessionActivityCreated;
            var updatedActivities = sortActivitiesByDate([
                sessionActivityCreated, 
            ].concat((0,_to_consumable_array/* default */.Z)(activities)));
            var updatedQuery = updateQuery(data, [
                "hostedSessionActivities",
                "activities"
            ], updatedActivities);
            client.writeQuery({
                query: GetHostedSessionActivitiesDocument,
                variables: variables,
                data: updatedQuery
            });
        }
    }, [
        onActivityCreated.data
    ]);
    return {
        activities: activities,
        loading: loading,
        error: error === null || error === void 0 ? void 0 : error.message,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSessionActivities/index.ts



;// CONCATENATED MODULE: ./src/components/Activities/context/ActivityProvider.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 







/**
 * Provider to store of the current activity being shown to user
 * and to determine the next activity from the activities list.
 */ var ActivityProvider = function(param) {
    var children = param.children;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(), currentActivity = ref[0], setCurrentActivity = ref[1];
    var ref1 = useSessionActivities(), activities = ref1.activities, loading = ref1.loading, error = ref1.error, refetch = ref1.refetch;
    var hasPendingActivities = function() {
        var pendingActivities = activities.filter(function(param) {
            var status = param.status;
            return status === ActivityStatus.Active;
        });
        return pendingActivities.length > 0;
    };
    var handleSetCurrent = function() {
        if ((0,lodash.isNil)(currentActivity) && hasPendingActivities()) {
            var firstActive = activities.find(function(param) {
                var status = param.status;
                return status === ActivityStatus.Active;
            });
            if (!(0,lodash.isNil)(firstActive)) {
                setCurrentActivity(firstActive);
            }
        }
    };
    var unsetCurrentActivity = function() {
        setCurrentActivity(undefined);
    };
    (0,react.useEffect)(function() {
        handleSetCurrent();
    }, [
        activities
    ]);
    (0,react.useEffect)(function() {
        handleSetCurrent();
    }, [
        currentActivity
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: t("activities.loading")
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.loading_error"),
            onRetry: refetch
        });
    }
    var waitingForNewActivities = (0,lodash.isNil)(currentActivity) || !hasPendingActivities();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityContext.Provider, {
        value: {
            currentActivity: currentActivity,
            unsetCurrentActivity: unsetCurrentActivity,
            waitingForNewActivities: waitingForNewActivities
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Activities/context/index.ts



;// CONCATENATED MODULE: ./src/components/Activities/hooks/useCurrentActivity.ts


var useCurrentActivity = function() {
    return (0,react.useContext)(ActivityContext);
};

;// CONCATENATED MODULE: ./src/components/Activities/hooks/index.ts


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/hooks/useMessage/types.ts


// EXTERNAL MODULE: ./node_modules/graphql/error/GraphQLError.mjs + 4 modules
var GraphQLError = __webpack_require__(3896);
;// CONCATENATED MODULE: ./src/hooks/useMessage/useMessage.ts










var useMessage = function(activity) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activity.id, _object = activity.object, message_id = _object.id;
    var ref = (0,_sliced_to_array/* default */.Z)(useMarkMessageAsReadMutation(), 1), markMessageAsRead = ref[0];
    var unsetCurrentActivity = useCurrentActivity().unsetCurrentActivity;
    var variables = {
        id: message_id
    };
    var ref1 = useGetMessageQuery({
        variables: variables,
        onError: function(error) {
            (0,esm_exports/* captureException */.Tb)(error, {
                contexts: {
                    message: {
                        message_id: message_id
                    },
                    activity: (0,src_object_spread/* default */.Z)({}, activity),
                    graphql: {
                        query: "GetMessage",
                        variables: JSON.stringify(variables)
                    }
                }
            });
            GraphQLError/* GraphQLError */.__;
        }
    }), data = ref1.data, loading = ref1.loading, error = ref1.error, refetch = ref1.refetch;
    var onRead = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var markMessageAsReadVariables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        markMessageAsReadVariables = {
                            input: {
                                activity_id: activity_id
                            }
                        };
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return markMessageAsRead({
                            variables: markMessageAsReadVariables
                        });
                    case 4:
                        unsetCurrentActivity();
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.message.toast_mark_as_read_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                graphql: {
                                    query: "MarkMessageAsRead",
                                    variables: JSON.stringify(markMessageAsReadVariables)
                                }
                            }
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function onRead() {
            return _ref.apply(this, arguments);
        };
    }();
    if (loading) {
        return {
            loading: loading,
            onRead: onRead
        };
    }
    if (error) {
        return {
            error: error.message,
            loading: false,
            onRead: onRead,
            refetch: refetch
        };
    }
    return {
        loading: loading,
        message: data === null || data === void 0 ? void 0 : data.message.message,
        onRead: onRead,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useMessage/index.ts



// EXTERNAL MODULE: ./src/components/ErrorPage/index.ts + 1 modules
var ErrorPage = __webpack_require__(6211);
// EXTERNAL MODULE: ./src/assets/link.svg
var assets_link = __webpack_require__(4311);
var link_default = /*#__PURE__*/__webpack_require__.n(assets_link);
// EXTERNAL MODULE: ./src/services/ErrorReporter/index.ts + 1 modules
var ErrorReporter = __webpack_require__(8644);
// EXTERNAL MODULE: ./src/services/ErrorReporter/addSentryBreadcrumb.ts
var addSentryBreadcrumb = __webpack_require__(2041);
;// CONCATENATED MODULE: ./src/components/Message/Message.tsx











var Message = function(param) {
    var activity = param.activity;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useMessage(activity), loading = ref.loading, message = ref.message, error = ref.error, onRead = ref.onRead, refetch = ref.refetch;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: t("activities.message.loading")
        });
    }
    if (error || !message) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.message.loading_error"),
            onRetry: refetch
        });
    }
    var handleReadMessage = function() {
        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.READ_MESSAGE */.j.READ_MESSAGE,
            data: {
                message: message === null || message === void 0 ? void 0 : message.id
            }
        });
        onRead();
    };
    var _subject;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Message, {
        content: message.body,
        subject: (_subject = message.subject) !== null && _subject !== void 0 ? _subject : "",
        attachments: message.attachments || [],
        attachmentIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: (link_default()),
            alt: "",
            width: 20,
            height: 20
        }),
        attachmentLabels: {
            video: t("activities.message.open_video_attachment"),
            link: t("activities.message.open_link_attachment"),
            file: t("activities.message.download_file_attachment")
        },
        onMessageRead: handleReadMessage,
        buttonLabels: {
            readMessage: t("activities.message.cta_mark_as_read")
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Message/index.ts


;// CONCATENATED MODULE: ./src/hooks/useChecklist/types.ts


;// CONCATENATED MODULE: ./src/hooks/useChecklist/useChecklist.ts



var useChecklist = function(activity) {
    var _object = activity.object, checklist_id = _object.id;
    var variables = {
        id: checklist_id
    };
    var ref = useGetChecklistQuery({
        variables: variables,
        onError: function(error) {
            (0,esm_exports/* captureException */.Tb)(error, {
                contexts: {
                    checklist: {
                        checklist_id: checklist_id
                    },
                    activity: (0,src_object_spread/* default */.Z)({}, activity),
                    graphql: {
                        query: "GetChecklist",
                        variables: JSON.stringify(variables)
                    }
                }
            });
        }
    }), data = ref.data, loading = ref.loading, error = ref.error, refetch = ref.refetch;
    if (loading) {
        return {
            loading: loading
        };
    }
    if (error) {
        return {
            loading: false,
            error: error.message,
            refetch: refetch
        };
    }
    // @ts-expect-error
    var ref1 = data === null || data === void 0 ? void 0 : data.checklist.checklist, _items = ref1.items, items = _items === void 0 ? [] : _items, _title = ref1.title, title = _title === void 0 ? "" : _title;
    var formatted_items = items.map(function(item, index) {
        return {
            id: index.toString(),
            label: item
        };
    });
    return {
        loading: loading,
        title: title,
        items: formatted_items,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useChecklist/index.ts


;// CONCATENATED MODULE: ./src/hooks/useSubmitChecklist/types.ts


;// CONCATENATED MODULE: ./src/hooks/useSubmitChecklist/useSubmitChecklist.ts









var useSubmitChecklist = function(activity) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activity.id;
    var ref = (0,_sliced_to_array/* default */.Z)(useSubmitChecklistMutation(), 1), submitChecklist = ref[0];
    var unsetCurrentActivity = useCurrentActivity().unsetCurrentActivity;
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var variables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        variables = {
                            input: {
                                activity_id: activity_id
                            }
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return submitChecklist({
                            variables: variables
                        });
                    case 5:
                        unsetCurrentActivity();
                        _ctx.next = 13;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        setIsSubmitting(false);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.checklist.saving_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                activity: activity,
                                graphql: {
                                    query: "SubmitChecklist",
                                    variables: JSON.stringify(variables)
                                }
                            }
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onSubmit: onSubmit,
        isSubmitting: isSubmitting
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSubmitChecklist/index.ts


;// CONCATENATED MODULE: ./src/components/Checklist/Checklist.tsx










var Checklist = function(param) {
    var activity = param.activity;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useChecklist(activity), loading = ref.loading, items = ref.items, title = ref.title, error = ref.error, refetch = ref.refetch;
    var ref1 = useSubmitChecklist(activity), onSubmit = ref1.onSubmit, isSubmitting = ref1.isSubmitting;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: t("activities.checklist.loading")
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.checklist.loading_error", {
                error: error
            }),
            onRetry: refetch
        });
    }
    var handleSubmit = function() {
        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.SUBMIT_CHECKLIST */.j.SUBMIT_CHECKLIST,
            data: {
                checklist_id: activity.object.id
            }
        });
        onSubmit();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Checklist, {
        title: title || "",
        items: items || [],
        onSubmit: handleSubmit,
        disabled: isSubmitting,
        submitLabel: t("activities.checklist.cta_submit")
    });
};
Checklist.displayName = "Checklist";

;// CONCATENATED MODULE: ./src/components/Checklist/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./src/components/Extension/utils.ts



var mapActionFieldsToObject = function(fields) {
    return fields.reduce(function(previousValue, currentValue) {
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValue), (0,_define_property/* default */.Z)({}, currentValue.id, currentValue.value));
    }, {});
};
var mapSettingsToObject = function(settings) {
    return settings === null || settings === void 0 ? void 0 : settings.reduce(function(previousValue, currentValue) {
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValue), (0,_define_property/* default */.Z)({}, currentValue.key, currentValue.value));
    }, {});
};

;// CONCATENATED MODULE: ./src/hooks/useCompleteExtensionActivity/types.ts


;// CONCATENATED MODULE: ./src/hooks/useCompleteExtensionActivity/useCompleteExtensionActivity.ts









var useCompleteExtensionActivity = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(useCompleteExtensionActivityMutation(), 1), completeExtensionActivity = ref1[0];
    var unsetCurrentActivity = useCurrentActivity().unsetCurrentActivity;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activity_id, data_points) {
            var variables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        variables = {
                            input: {
                                activity_id: activity_id,
                                data_points: data_points
                            }
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return completeExtensionActivity({
                            variables: variables
                        });
                    case 5:
                        unsetCurrentActivity();
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.checklist.saving_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                activity: {
                                    activity_id: activity_id
                                },
                                graphql: {
                                    query: "CompleteExtensionActivity",
                                    variables: JSON.stringify(variables)
                                }
                            }
                        });
                    case 12:
                        _ctx.prev = 12;
                        setIsSubmitting(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function(activity_id, data_points) {
            return _ref.apply(this, arguments);
        };
    }(), [
        completeExtensionActivity,
        t
    ]);
    return {
        onSubmit: onSubmit,
        isSubmitting: isSubmitting
    };
};

;// CONCATENATED MODULE: ./src/hooks/useCompleteExtensionActivity/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/types.ts

var ActionKey;
(function(ActionKey) {
    ActionKey["BOOK_APPOINTMENT"] = "bookAppointment";
})(ActionKey || (ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/useCompleteBookAppointment.ts




var useCompleteBookAppointment = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, data) {
            var ref, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        dataPoints = [
                            {
                                key: "bookingId",
                                value: "".concat(data === null || data === void 0 ? void 0 : (ref = data.booking) === null || ref === void 0 ? void 0 : ref.id)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/BookAppointmentAction.tsx





var BookAppointmentAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, pathway_id = activityDetails.pathway_id;
    var onSubmit = useCompleteBookAppointment().onSubmit;
    var calLink = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).calLink;
    var onBookingSuccessful = (0,react.useCallback)(function(data) {
        onSubmit(activity_id, data);
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CalDotComScheduling, {
        calLink: calLink,
        metadata: {
            awellPathwayId: pathway_id,
            awellActivityId: activity_id
        },
        onBookingSuccessful: onBookingSuccessful
    });
};
BookAppointmentAction.displayName = "BookAppointmentAction";

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/CalDotComExtension.tsx






var CalDotComExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case ActionKey.BOOK_APPOINTMENT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BookAppointmentAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
CalDotComExtension.displayName = "CalDotComExtension";

;// CONCATENATED MODULE: ./src/components/Extension/CalDotComExtension/index.ts


// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(6793);
;// CONCATENATED MODULE: ./src/hooks/useExtensionActivity/types.ts


;// CONCATENATED MODULE: ./src/hooks/useExtensionActivity/useExtensionActivity.ts




var useExtensionActivity = function(id) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = useGetExtensionActivityDetailsQuery({
        variables: {
            id: id
        },
        nextFetchPolicy: "cache-first"
    }), data = ref.data, loading = ref.loading, error = ref.error, refetch = ref.refetch;
    (0,react.useEffect)(function() {
        void refetch();
    }, [
        id
    ]);
    if (!(0,lodash.isNil)(error)) {
        return {
            loading: false,
            error: error.message,
            refetch: refetch
        };
    }
    if (loading) {
        return {
            loading: true
        };
    }
    return {
        loading: false,
        extensionActivityDetails: data === null || data === void 0 ? void 0 : data.extensionActivityRecord.record,
        refetch: refetch
    };
};

;// CONCATENATED MODULE: ./src/hooks/useExtensionActivity/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/types.ts
var ExtensionKey;
(function(ExtensionKey) {
    ExtensionKey["CAL_DOT_COM"] = "calDotCom";
    ExtensionKey["FORMSORT"] = "formsort";
    ExtensionKey["DROPBOXSIGN"] = "dropboxSign";
    ExtensionKey["CLOUDINARY"] = "cloudinary";
    ExtensionKey["DOCU_SIGN"] = "docuSign";
    ExtensionKey["COLLECT_DATA"] = "collectData";
})(ExtensionKey || (ExtensionKey = {}));

// EXTERNAL MODULE: ./node_modules/@formsort/react-embed/lib/index.js
var react_embed_lib = __webpack_require__(4914);
// EXTERNAL MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/completeFlowAction.module.css
var completeFlowAction_module = __webpack_require__(4612);
var completeFlowAction_module_default = /*#__PURE__*/__webpack_require__.n(completeFlowAction_module);
;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/types.ts

var types_ActionKey;
(function(ActionKey) {
    ActionKey["COMPLETE_FLOW"] = "completeFlow";
})(types_ActionKey || (types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/hooks/useCompleteCompleteFlowAction.tsx




var useCompleteCompleteFlowAppointment = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId) {
            var dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataPoints = [];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/CompleteFlowAction.tsx






var CompleteFlowAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings;
    var onSubmit = useCompleteCompleteFlowAppointment().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), clientLabel = ref.clientLabel, flowLabel = ref.flowLabel, variantLabel = ref.variantLabel;
    var environment = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        fields
    ]).environment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (completeFlowAction_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_embed_lib/* default */.ZP, {
            clientLabel: clientLabel,
            flowLabel: flowLabel,
            variantLabel: variantLabel,
            formsortEnv: environment,
            embedConfig: {
                style: {
                    width: "100%",
                    height: "100%"
                }
            },
            onFlowFinalized: function(answers) {
                console.log(answers);
                onSubmit(activity_id);
            }
        })
    });
};
CompleteFlowAction.displayName = "CompleteFlowAction";

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/CompleteFlowAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/actions/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/FormsortExtension.tsx






var FormsortExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case types_ActionKey.COMPLETE_FLOW:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteFlowAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
FormsortExtension.displayName = "FormsortExtension";

;// CONCATENATED MODULE: ./src/components/Extension/FormsortExtension/index.tsx


// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var zod_lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/types.ts



var DropboxSignExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["EMBEDDED_SIGNING"] = "embeddedSigning";
})(DropboxSignExtension_types_ActionKey || (DropboxSignExtension_types_ActionKey = {}));
var SettingsValidationSchema = zod_lib.z.object({
    clientId: zod_lib.z.string(),
    testMode: zod_lib.z.optional(zod_lib.z["enum"]([
        "Yes",
        "No",
        "yes",
        "no"
    ])).transform(function(testMode) {
        if ((0,lodash.isEmpty)(testMode) || (0,lodash.isNil)(testMode)) return false;
        var serializedTestmode = (0,lodash.lowerCase)(testMode);
        if (serializedTestmode === "yes") return true;
        return false;
    })
});
var validateSettings = function(settings) {
    var parsedData = SettingsValidationSchema.parse(settings);
    return parsedData;
};

;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/EmbeddedSigningAction/hooks/useCompleteEmbeddedSigningAction.tsx




var useCompleteEmbeddedSigningAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, param) {
            var signed, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        signed = param.signed;
                        dataPoints = [
                            {
                                key: "signed",
                                value: String(signed)
                            }
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, _) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js + 2 modules
var isAfter = __webpack_require__(4966);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(6492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/EmbeddedSigningAction/EmbeddedSigningAction.tsx








var EmbeddedSigningAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings;
    var onSubmit = useCompleteEmbeddedSigningAction().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), signUrl = ref.signUrl, expiresAt = ref.expiresAt;
    /**
   * This is needed because Orchestration seems to encode string action field values
   * - Data point value: https://url.com/?signature_id=ABC&token=DEF
   * - Action field value https://url.com/?signature_id&#x3D;ABC&amp;token&#x3D;DEF
   *
   * We need the decoded action field value and he library helps us to force decode
   * the url to a valid one.
   */ var decodedSignUrl = he_default().decode(signUrl);
    var settingsData = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        settings
    ]);
    var ref1 = validateSettings(settingsData), testMode = ref1.testMode, clientId = ref1.clientId;
    /**
   * https://github.com/vercel/next.js/issues/35559
   */ var singDocument = function() {
        Promise.all(/* import() */[__webpack_require__.e(117), __webpack_require__.e(507)]).then(__webpack_require__.t.bind(__webpack_require__, 507, 23)).then(function(param) {
            var HelloSign = param.default;
            return new HelloSign({
                clientId: clientId
            });
        }).then(function(client) {
            client.open(decodedSignUrl, {
                allowCancel: true,
                testMode: testMode,
                debug: testMode,
                skipDomainVerification: true
            });
            /*
         ! Needs handling of all events; currently only `sign` event is handled
         ! https://github.com/hellosign/hellosign-embedded/wiki/API-Documentation-(v2)#events
         */ client.on("sign", function() {
                onSubmit(activity_id, {
                    signed: true
                });
            });
        });
    };
    var isSignUrlExpired = (0,isAfter/* default */.Z)(new Date(), new Date(expiresAt));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            padding: "12px 0 0 0"
        },
        children: isSignUrlExpired ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "The sign URL for this signature request is expired."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                    onClick: function() {
                        return onSubmit(activity_id, {
                            signed: false
                        });
                    },
                    children: "Continue"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
            onClick: singDocument,
            children: "Sign document"
        })
    });
};
EmbeddedSigningAction.displayName = "EmbeddedSigningAction";

;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/EmbeddedSigningAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/actions/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/DropboxSignExtension.tsx






var DropboxSignExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case DropboxSignExtension_types_ActionKey.EMBEDDED_SIGNING:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedSigningAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
DropboxSignExtension.displayName = "DropboxSignExtension";

;// CONCATENATED MODULE: ./src/components/Extension/DropboxSignExtension/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/types.ts

var CloudinaryExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["UPLOAD_FILES"] = "uploadFiles";
    ActionKey["UPLOAD_SINGLE_FILE"] = "uploadSingleFile";
})(CloudinaryExtension_types_ActionKey || (CloudinaryExtension_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadFilesAction/hooks/useCompleteUploadFilesAction.tsx




var useCompleteUploadFilesAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, fileUrls) {
            var dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataPoints = [];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, fileUrls) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadFilesAction/UploadFilesAction.tsx









var UploadFilesAction = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings, pathway_id = activityDetails.pathway_id;
    var onSubmit = useCompleteUploadFilesAction().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        settings
    ]), cloudName = ref.cloudName, uploadPresetSettings = ref.uploadPreset, folderSettings = ref.folder;
    var ref1 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), uploadPresetActionFields = ref1.uploadPreset, folderActionFields = ref1.folder, tags = ref1.tags;
    var ref2;
    var tagsArray = (0,react.useMemo)(function() {
        return (ref2 = tags === null || tags === void 0 ? void 0 : tags.split(",")) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        tags
    ]);
    var onSave = (0,react.useCallback)(function(files) {
        onSubmit(activity_id, files.map(function(file) {
            return file.url;
        }));
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CloudinaryUpload, {
        cloudName: cloudName,
        uploadPreset: !(0,lodash.isEmpty)(uploadPresetActionFields) && !(0,lodash.isNil)(uploadPresetActionFields) ? uploadPresetActionFields : uploadPresetSettings,
        folder: folderActionFields !== null && folderActionFields !== void 0 ? folderActionFields : folderSettings,
        tags: tagsArray,
        context: {
            awellPathwayId: pathway_id,
            awellActivityId: activity_id
        },
        onFinish: onSave,
        text: {
            subject: t("activities.cloudinary.subject"),
            attachmentIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (link_default()),
                alt: "",
                width: 20,
                height: 20
            }),
            attachmentLabels: {
                file: t("activities.cloudinary.file_attachment"),
                video: t("activities.cloudinary.video_attachment"),
                link: t("activities.cloudinary.link_attachment")
            },
            fileCountHeader: function(count) {
                return t("activities.cloudinary.file_count", {
                    count: count
                });
            },
            buttonLabels: {
                upload: t("activities.cloudinary.cta_upload_files"),
                done: t("activities.cta_done")
            }
        }
    });
};
UploadFilesAction.displayName = "UploadFilesAction";

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadFilesAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadSingleFileAction/hooks/useCompleteSingleUploadFileAction.tsx




var useCompleteSingleUploadFileAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, fileUrl) {
            var dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataPoints = [
                            {
                                key: "fileUrl",
                                value: String(fileUrl)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, fileUrl) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadSingleFileAction/UploadSingleFileAction.tsx









var UploadSingleFileAction = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields, settings = activityDetails.settings, pathway_id = activityDetails.pathway_id;
    var onSubmit = useCompleteSingleUploadFileAction().onSubmit;
    var ref = (0,react.useMemo)(function() {
        return mapSettingsToObject(settings);
    }, [
        settings
    ]), cloudName = ref.cloudName, uploadPresetSettings = ref.uploadPreset, folderSettings = ref.folder;
    var ref1 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), uploadPresetActionFields = ref1.uploadPreset, folderActionFields = ref1.folder, tags = ref1.tags;
    var ref2;
    var tagsArray = (0,react.useMemo)(function() {
        return (ref2 = tags === null || tags === void 0 ? void 0 : tags.split(",")) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        tags
    ]);
    var onSave = (0,react.useCallback)(function(file) {
        onSubmit(activity_id, String(file === null || file === void 0 ? void 0 : file.url));
    }, [
        activity_id,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CloudinarySingleFileUpload, {
        cloudName: cloudName,
        uploadPreset: !(0,lodash.isEmpty)(uploadPresetActionFields) && !(0,lodash.isNil)(uploadPresetActionFields) ? uploadPresetActionFields : uploadPresetSettings,
        folder: folderActionFields !== null && folderActionFields !== void 0 ? folderActionFields : folderSettings,
        tags: tagsArray,
        context: {
            awellPathwayId: pathway_id,
            awellActivityId: activity_id
        },
        onFinish: onSave,
        text: {
            subject: t("activities.cloudinary.single_file_upload_action.subject_single_file_upload"),
            attachmentIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (link_default()),
                alt: "",
                width: 20,
                height: 20
            }),
            attachmentLabels: {
                file: t("activities.cloudinary.file_attachment"),
                video: t("activities.cloudinary.video_attachment"),
                link: t("activities.cloudinary.link_attachment")
            },
            fileCountHeader: function(fileUploaded) {
                return fileUploaded ? t("activities.cloudinary.single_file_upload_action.no_file_uploaded") : t("activities.cloudinary.single_file_upload_action.file_uploaded");
            },
            buttonLabels: {
                upload: t("activities.cloudinary.single_file_upload_action.cta_upload_file"),
                done: t("activities.cta_done")
            }
        }
    });
};
UploadSingleFileAction.displayName = "UploadSingleFileAction";

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/UploadSingleFileAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/actions/index.tsx



;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/CloudinaryExtension.tsx






var CloudinaryExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case CloudinaryExtension_types_ActionKey.UPLOAD_FILES:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadFilesAction, {
                activityDetails: activityDetails
            });
        case CloudinaryExtension_types_ActionKey.UPLOAD_SINGLE_FILE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadSingleFileAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
CloudinaryExtension.displayName = "CloudinaryExtension";

;// CONCATENATED MODULE: ./src/components/Extension/CloudinaryExtension/index.tsx


// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(7563);
;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/types.ts

var DocuSignExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["EMBEDDED_SIGNING"] = "embeddedSigning";
})(DocuSignExtension_types_ActionKey || (DocuSignExtension_types_ActionKey = {}));
var WindowEventType;
(function(WindowEventType) {
    WindowEventType["DOCU_SIGN_SET_EVENT"] = "docu_sign_set_event";
})(WindowEventType || (WindowEventType = {}));
var DocuSignEvent;
(function(DocuSignEvent) {
    DocuSignEvent[// Recipient used incorrect access code.
    "ACCESS_CODE_FAILED"] = "access_code_failed";
    DocuSignEvent[// Recipient canceled the signing operation, possibly by using the Finish Later option.
    "CANCEL"] = "cancel";
    DocuSignEvent[// Recipient declined to sign.
    "DECLINE"] = "decline";
    DocuSignEvent[// A system error occurred during the signing process.
    "EXCEPTION"] = "exception";
    DocuSignEvent[// Recipient has a fax pending.
    "FAX_PENDING"] = "fax_pending";
    DocuSignEvent[// Recipient failed an ID check.
    "ID_CHECK_FAILED"] = "id_check_failed";
    DocuSignEvent[// The session timed out. An account can control this timeout by using the Signer Session Timeout option.
    "SESSION_TIMEOUT"] = "session_timeout";
    DocuSignEvent[// The recipient completed the signing ceremony.
    "SIGNING_COMPLETE"] = "signing_complete";
    DocuSignEvent[// The Time To Live token for the envelope has expired. After being successfully invoked, these tokens expire after five minutes.
    "TTL_EXPIRED"] = "ttl_expired";
    DocuSignEvent[// The recipient completed viewing an envelope that is in a read-only/terminal state, such as completed, declined, or voided.
    "VIEWING_COMPLETE"] = "viewing_complete";
})(DocuSignEvent || (DocuSignEvent = {}));

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/hooks/useCompleteEmbeddedSigningAction.tsx




var useCompleteEmbeddedSigningAction_useCompleteEmbeddedSigningAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(activityId, param) {
            var signed, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        signed = param.signed;
                        dataPoints = [
                            {
                                key: "signed",
                                value: String(signed)
                            }
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(activityId, _) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/IFrameMessager.tsx



var IFrameMessager = function(param) {
    var iframeEvent = param.iframeEvent, setEvent = param.setEvent;
    var isIframe = !!iframeEvent;
    var handleDocuSignEvent = (0,react.useCallback)(function(event) {
        var ref;
        // validate domain
        if (event.origin !== location.origin) {
            return;
        }
        switch((ref = event.data) === null || ref === void 0 ? void 0 : ref.type){
            case WindowEventType.DOCU_SIGN_SET_EVENT:
                setEvent(event.data.event);
                break;
            default:
                break;
        }
    }, [
        setEvent
    ]);
    (0,react.useEffect)(function() {
        if (isIframe) {
            var ref;
            (ref = window.top) === null || ref === void 0 ? void 0 : ref.postMessage({
                event: iframeEvent,
                type: WindowEventType.DOCU_SIGN_SET_EVENT
            }, location.origin);
        } else {
            window.addEventListener("message", handleDocuSignEvent, false);
            return function() {
                window.removeEventListener("message", handleDocuSignEvent, false);
            };
        }
    }, [
        handleDocuSignEvent,
        iframeEvent,
        isIframe
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
IFrameMessager.displayName = "IFrameMessager";

// EXTERNAL MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/embeddedSigning.module.css
var embeddedSigning_module = __webpack_require__(1397);
var embeddedSigning_module_default = /*#__PURE__*/__webpack_require__.n(embeddedSigning_module);
;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/SigningProcess.tsx






var SigningProcess = function(param) {
    var signUrl = param.signUrl, isIframeLoaded = param.isIframeLoaded, setIsIframeLoaded = param.setIsIframeLoaded;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isSignProcess = ref[0], setIsSignProcess = ref[1];
    var beginSigning = function() {
        setIsSignProcess(true);
    };
    if (isSignProcess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !isIframeLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
                    title: t("activities.docu_sign.loading_sign_document")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: isIframeLoaded ? (embeddedSigning_module_default())["iframe-loaded"] : (embeddedSigning_module_default())["iframe-loading"],
                    src: signUrl,
                    onLoad: function() {
                        setIsIframeLoaded(true);
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
            onClick: beginSigning,
            children: t("activities.docu_sign.cta_sign_document")
        })
    });
};
SigningProcess.displayName = "SigningProcess";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/FinishedMessage.tsx






var FinishedMessage = function(param) {
    var event = param.event, finishSigning = param.finishSigning;
    var t = (0,esm/* useTranslation */.$G)().t;
    var finishAndFailSigning = function() {
        finishSigning({
            signed: false
        });
    };
    switch(event){
        case DocuSignEvent.SIGNING_COMPLETE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
                title: t("activities.docu_sign.finished_sign_document")
            });
        case DocuSignEvent.TTL_EXPIRED:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: t("activities.docu_sign.expired_sign_document")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            onClick: finishAndFailSigning,
                            children: t("activities.cta_done")
                        })
                    ]
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: t("activities.docu_sign.failed_sign_document")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            onClick: finishAndFailSigning,
                            children: t("activities.cta_done")
                        })
                    ]
                })
            });
    }
};
FinishedMessage.displayName = "FinishedMessage";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/EmbeddedSigningAction.tsx











var EmbeddedSigningAction_EmbeddedSigningAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var onSubmit = useCompleteEmbeddedSigningAction_useCompleteEmbeddedSigningAction().onSubmit;
    var ref;
    // visible in IFrame only
    var ref1 = (ref = (0,query_string.parse)(location.search)) !== null && ref !== void 0 ? ref : {}, iframeEvent = ref1.event;
    var ref2 = (0,react.useState)(false), isIframeLoaded = ref2[0], setIsIframeLoaded = ref2[1];
    var ref3 = (0,react.useState)(undefined), event = ref3[0], setEvent = ref3[1];
    var isFinished = !!event;
    var isIframe = !!iframeEvent;
    var signUrl = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]).signUrl;
    /**
   * This is needed because Orchestration seems to encode string action field values
   * - Data point value: https://url.com/?signature_id=ABC&token=DEF
   * - Action field value https://url.com/?signature_id&#x3D;ABC&amp;token&#x3D;DEF
   *
   * We need the decoded action field value and he library helps us to force decode
   * the url to a valid one.
   */ var decodedSignUrl = he_default().decode(signUrl);
    var finishSigning = (0,react.useCallback)(function(param) {
        var signed = param.signed;
        onSubmit(activity_id, {
            signed: signed
        });
    }, [
        activity_id,
        onSubmit
    ]);
    (0,react.useEffect)(function() {
        if (isFinished) {
            setIsIframeLoaded(false);
            if (event === DocuSignEvent.SIGNING_COMPLETE) {
                finishSigning({
                    signed: true
                });
            }
        }
    }, [
        event,
        finishSigning,
        isFinished
    ]);
    // this window is iframe content -> render only messager
    if (isIframe) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameMessager, {
            iframeEvent: iframeEvent,
            setEvent: setEvent
        });
    }
    // this window is extension content -> render messager and extension
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameMessager, {
                iframeEvent: iframeEvent,
                setEvent: setEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // if iframe is loaded -> fill screen
                className: "".concat((embeddedSigning_module_default()).wrapper, " ").concat(isIframeLoaded ? (embeddedSigning_module_default())["flex-full"] : ""),
                children: isFinished ? // signing process is finished -> display messsage
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishedMessage, {
                    event: event,
                    finishSigning: finishSigning
                }) : // signing process incomplete (or user refreshed page) -> display signing process
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SigningProcess, {
                    signUrl: decodedSignUrl,
                    isIframeLoaded: isIframeLoaded,
                    setIsIframeLoaded: setIsIframeLoaded
                })
            })
        ]
    });
};
EmbeddedSigningAction_EmbeddedSigningAction.displayName = "EmbeddedSigningAction";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/EmbeddedSigningAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/actions/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/DocuSignExtension.tsx






var DocuSignExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case DocuSignExtension_types_ActionKey.EMBEDDED_SIGNING:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedSigningAction_EmbeddedSigningAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
DocuSignExtension.displayName = "DropboxSignExtension";

;// CONCATENATED MODULE: ./src/components/Extension/DocuSignExtension/index.tsx


// EXTERNAL MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/remoteSingleSelectAction.module.css
var remoteSingleSelectAction_module = __webpack_require__(7640);
var remoteSingleSelectAction_module_default = /*#__PURE__*/__webpack_require__.n(remoteSingleSelectAction_module);
;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/types.ts

var CollectDataExtension_types_ActionKey;
(function(ActionKey) {
    ActionKey["REMOTE_SINGLE_SELECT"] = "remoteSingleSelect";
})(CollectDataExtension_types_ActionKey || (CollectDataExtension_types_ActionKey = {}));

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/hooks/useRemoteSingleSelectAction.tsx




var useRemoteSingleSelectAction = function() {
    var ref = useCompleteExtensionActivity(), isSubmitting = ref.isSubmitting, _onSubmit = ref.onSubmit;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var activityId, label, value, dataPoints;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        activityId = param.activityId, label = param.label, value = param.value;
                        dataPoints = [
                            {
                                key: "label",
                                value: String(label)
                            },
                            {
                                key: "value",
                                value: String(value)
                            }, 
                        ];
                        return _ctx.abrupt("return", _onSubmit(activityId, dataPoints));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        _onSubmit
    ]);
    return {
        isSubmitting: isSubmitting,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/RemoteSingleSelectAction.tsx











var RemoteSingleSelectAction = function(param) {
    var activityDetails = param.activityDetails;
    var activity_id = activityDetails.activity_id, fields = activityDetails.fields;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useRemoteSingleSelectAction(), onSubmit = ref.onSubmit, isSubmitting = ref.isSubmitting;
    var ref1 = (0,react.useState)(), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var ref2 = (0,react.useState)([]), options = ref2[0], setOptions = ref2[1];
    var ref3 = (0,react.useState)(), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(""), searchText = ref4[0], setSearchText = ref4[1];
    var handleFetchOptions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url, queryParam, headers) {
            var search, onError, response, options, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        search = _args.length > 3 && _args[3] !== void 0 ? _args[3] : "", onError = _args.length > 4 ? _args[4] : void 0;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetch("".concat(url, "/").concat(queryParam && search ? "?" + queryParam + "=" + search : ""), {
                            method: "GET",
                            headers: (0,src_object_spread/* default */.Z)({
                                "Content-Type": "application/json",
                                "ngrok-skip-browser-warning": "yes"
                            }, JSON.parse(headers))
                        });
                    case 4:
                        response = _ctx.sent;
                        _ctx.next = 7;
                        return response.json();
                    case 7:
                        options = _ctx.sent;
                        return _ctx.abrupt("return", options);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                        if (!(0,lodash.isNil)(onError)) {
                            onError(_ctx.t0);
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function handleFetchOptions(url, queryParam, headers) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref5 = (0,react.useMemo)(function() {
        return mapActionFieldsToObject(fields);
    }, [
        fields
    ]), queryParam = ref5.queryParam, url = ref5.url, label = ref5.label, _headers = ref5.headers, headers = _headers === void 0 ? "{}" : _headers, _mandatory = ref5.mandatory, mandatory = _mandatory === void 0 ? false : _mandatory;
    var fetchOptions = (0,lodash.debounce)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var options;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return handleFetchOptions(url, queryParam, headers, searchText, setError);
                case 2:
                    options = _ctx.sent;
                    setOptions(options);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), 1000);
    var handleSubmit = function() {
        if ((0,lodash.isNil)(selectedOption) || (0,lodash.isNil)(selectedOption.value)) {
            setError(t("activities.form.question_required_error"));
            return;
        }
        onSubmit({
            activityId: activity_id,
            label: selectedOption.label,
            value: selectedOption.value.toString()
        });
    };
    console.log(mandatory);
    (0,react.useEffect)(function() {
        if (searchText.length > 3) {
            fetchOptions();
        }
    }, [
        searchText
    ]);
    if (!activityDetails || !activityDetails.fields || !options) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (remoteSingleSelectAction_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (remoteSingleSelectAction_module_default()).selectContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                        id: "select",
                        labels: {
                            questionLabel: label,
                            noOptions: t("activities.form.questions.select.no_options"),
                            searchPlaceholder: t("activities.form.questions.select.type_to_search")
                        },
                        options: options,
                        onSearch: function(value) {
                            setSearchText(value);
                        },
                        type: "single",
                        value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value,
                        onChange: function(value) {
                            var selectedOption = options.find(function(option) {
                                return option.value.toString() === value.toString();
                            });
                            setSelectedOption(selectedOption);
                        },
                        mandatory: mandatory === "true",
                        filtering: true
                    }),
                    !(0,lodash.isNil)(error) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (remoteSingleSelectAction_module_default()).error,
                        children: String(error)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (remoteSingleSelectAction_module_default()).buttonContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                    onClick: handleSubmit,
                    disabled: isSubmitting,
                    children: t("activities.form.cta_submit")
                })
            })
        ]
    });
};
RemoteSingleSelectAction.displayName = "RemoteSingleSelectAction";

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/RemoteSingleSelectAction/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/actions/index.ts


;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/CollectDataExtension.tsx






var CollectDataExtension = function(param) {
    var activityDetails = param.activityDetails;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activityDetails.plugin_action_key){
        case CollectDataExtension_types_ActionKey.REMOTE_SINGLE_SELECT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteSingleSelectAction, {
                activityDetails: activityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
CollectDataExtension.displayName = "CollectDataExtension";

;// CONCATENATED MODULE: ./src/components/Extension/CollectDataExtension/index.tsx


;// CONCATENATED MODULE: ./src/components/Extension/Extension.tsx













var Extension = function(param) {
    var activity = param.activity;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = useExtensionActivity(activity.object.id), loading = ref1.loading, extensionActivityDetails = ref1.extensionActivityDetails, error = ref1.error, refetch = ref1.refetch;
    console.log("extensionActivityDetails", extensionActivityDetails);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: t("activities.checklist.loading")
        });
    }
    if (error || !extensionActivityDetails) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.checklist.loading_error", {
                error: error
            }),
            onRetry: refetch
        });
    }
    switch(activity === null || activity === void 0 ? void 0 : (ref = activity.indirect_object) === null || ref === void 0 ? void 0 : ref.id){
        case ExtensionKey.CAL_DOT_COM:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalDotComExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.DROPBOXSIGN:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropboxSignExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.CLOUDINARY:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.FORMSORT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormsortExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.DOCU_SIGN:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocuSignExtension, {
                activityDetails: extensionActivityDetails
            });
        case ExtensionKey.COLLECT_DATA:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectDataExtension, {
                activityDetails: extensionActivityDetails
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};
Extension.displayName = "Extension";

;// CONCATENATED MODULE: ./src/components/Extension/index.ts


;// CONCATENATED MODULE: ./src/components/Activities/ActivityFactory.tsx









var ActivityFactory = function(param) {
    var activity = param.activity;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(activity === null || activity === void 0 ? void 0 : activity.object.type){
        case ActivityObjectType.Form:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                activity: activity
            }, activity.id);
        case ActivityObjectType.Message:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                activity: activity
            }, activity.id);
        case ActivityObjectType.Checklist:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checklist, {
                activity: activity
            }, activity.id);
        case ActivityObjectType.PluginAction:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Extension, {
                activity: activity
            }, activity.id);
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: t("activities.activity_not_supported")
            });
    }
};

;// CONCATENATED MODULE: ./src/components/Activities/Activities.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 





// session will already expire after 15 seconds
var TIMEOUT_DELAY = 10000;
var RELOAD_DELAY = 20000;
var Activities = function() {
    var ref = useCurrentActivity(), currentActivity = ref.currentActivity, waitingForNewActivities = ref.waitingForNewActivities;
    var t = (0,esm/* useTranslation */.$G)().t;
    var initialMessage = t("activities.waiting_for_new_activities");
    var unexpectedMessage = t("activities.waiting_unexpected");
    var ref1 = (0,react.useState)(initialMessage), message = ref1[0], setMessage = ref1[1];
    (0,react.useEffect)(function() {
        var timeoutTimer;
        var reloadTimer;
        if (waitingForNewActivities) {
            timeoutTimer = setTimeout(function() {
                setMessage(unexpectedMessage);
            }, TIMEOUT_DELAY);
            reloadTimer = setTimeout(function() {
                window.location.reload();
            }, RELOAD_DELAY);
        }
        // clear interval on component unmount
        return function() {
            if (timeoutTimer) {
                clearTimeout(timeoutTimer);
            }
            if (reloadTimer) {
                clearTimeout(reloadTimer);
            }
        };
    }, [
        waitingForNewActivities
    ]);
    if (waitingForNewActivities) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: message
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFactory, {
        activity: currentActivity
    });
};

;// CONCATENATED MODULE: ./src/components/Activities/ActivitiesContainer.tsx




var ActivitiesContainer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Activities, {})
    });
};

;// CONCATENATED MODULE: ./src/components/Activities/index.ts



;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/useSubmitForm.ts









var useSubmitForm = function(activity) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var activity_id = activity.id;
    var unsetCurrentActivity = useCurrentActivity().unsetCurrentActivity;
    var ref = (0,_sliced_to_array/* default */.Z)(useSubmitFormResponseMutation(), 1), submitFormResponse = ref[0];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var variables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSubmitting(true);
                        variables = {
                            input: {
                                activity_id: activity_id,
                                response: response
                            }
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return submitFormResponse({
                            variables: variables
                        });
                    case 5:
                        unsetCurrentActivity();
                        _ctx.next = 13;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        setIsSubmitting(false);
                        react_toastify_esm/* toast.error */.Am.error(t("activities.form.saving_error"));
                        (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                            contexts: {
                                activity: activity,
                                form: {
                                    response: JSON.stringify(variables)
                                },
                                graphql: {
                                    query: "SubmitFormResponse",
                                    variables: JSON.stringify(variables)
                                }
                            }
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function onSubmit(response) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onSubmit: onSubmit,
        disabled: isSubmitting
    };
};

;// CONCATENATED MODULE: ./src/hooks/useSubmitForm/index.ts


// EXTERNAL MODULE: ./node_modules/use-local-storage/dist/index.js
var use_local_storage_dist = __webpack_require__(7844);
var use_local_storage_dist_default = /*#__PURE__*/__webpack_require__.n(use_local_storage_dist);
;// CONCATENATED MODULE: ./src/components/Form/Form.tsx


















var Form = function(param) {
    var activity = param.activity;
    var ref = useForm(activity), loading = ref.loading, form = ref.form, error = ref.error, refetch = ref.refetch;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useEvaluateFormRules(activity.object.id), 1), evaluateFormRules = ref1[0];
    var onSubmit = useSubmitForm(activity).onSubmit;
    var branding = useHostedSession().branding;
    var ref2 = (0,_sliced_to_array/* default */.Z)(use_local_storage_dist_default()(activity.id, ""), 2), formProgress = ref2[0], setFormProgress = ref2[1];
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: t("activities.form.loading")
        });
    }
    if (error || (0,lodash.isNil)(form)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("activities.form.loading_error"),
            onRetry: refetch
        });
    }
    var handleEvaluateFormRules = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                            category: addSentryBreadcrumb/* BreadcrumbCategory.EVALUATE_FORM_RULES */.j.EVALUATE_FORM_RULES,
                            data: {
                                form_id: form === null || form === void 0 ? void 0 : form.id,
                                response: (0,ErrorReporter/* masker */.g)(response)
                            }
                        });
                        return _ctx.abrupt("return", evaluateFormRules(response));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleEvaluateFormRules(response) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                            category: addSentryBreadcrumb/* BreadcrumbCategory.SUBMIT_FORM */.j.SUBMIT_FORM,
                            data: {
                                form_id: form === null || form === void 0 ? void 0 : form.id,
                                response: (0,ErrorReporter/* masker */.g)(response)
                            }
                        });
                        setFormProgress(undefined);
                        _ctx.next = 4;
                        return onSubmit(response);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(response) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnAnswersChange = function(response) {
        if (response !== formProgress) {
            setFormProgress(response);
        }
    };
    var labels = {
        yes_label: t("activities.form.questions.yes_no.yes_answer"),
        no_label: t("activities.form.questions.yes_no.no_answer"),
        select: {
            search_placeholder: t("activities.form.questions.select.search_placeholder"),
            no_options: t("activities.form.questions.select.no_options")
        },
        slider: {
            tooltip_guide: t("activities.form.questions.slider.tooltip_guide")
        }
    };
    var button_labels = {
        prev: t("activities.form.previous_question_label"),
        next: t("activities.form.next_question_label"),
        submit: t("activities.form.cta_submit"),
        start_form: t("activities.form.cta_start_form")
    };
    var error_labels = {
        required: t("activities.form.question_required_error"),
        sliderNotTouched: t("activities.form.slider_not_touched_error"),
        invalidPhoneNumber: t("activities.form.invalid_phone_number"),
        formHasErrors: t("activities.form.form_has_errors")
    };
    var renderTraditionalForm = activity.form_display_mode && activity.form_display_mode === FormDisplayMode.Regular;
    var ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderTraditionalForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TraditionalForm, {
                form: form,
                questionLabels: labels,
                buttonLabels: button_labels,
                errorLabels: error_labels,
                onSubmit: handleSubmit,
                evaluateDisplayConditions: handleEvaluateFormRules,
                storedAnswers: formProgress,
                onAnswersChange: handleOnAnswersChange,
                autosaveAnswers: (ref3 = branding === null || branding === void 0 ? void 0 : branding.hosted_page_autosave) !== null && ref3 !== void 0 ? ref3 : true
            }),
            !renderTraditionalForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ConversationalForm, {
                form: form,
                questionLabels: labels,
                buttonLabels: button_labels,
                errorLabels: error_labels,
                onSubmit: handleSubmit,
                evaluateDisplayConditions: handleEvaluateFormRules,
                storedAnswers: formProgress,
                onAnswersChange: handleOnAnswersChange,
                autoProgress: (ref4 = branding === null || branding === void 0 ? void 0 : branding.hosted_page_auto_progress) !== null && ref4 !== void 0 ? ref4 : false,
                autosaveAnswers: (ref5 = branding === null || branding === void 0 ? void 0 : branding.hosted_page_autosave) !== null && ref5 !== void 0 ? ref5 : true
            })
        ]
    });
};
Form.displayName = "Form";

;// CONCATENATED MODULE: ./src/components/Form/index.ts


;// CONCATENATED MODULE: ./src/components/CloseHostedSessionModal/CloseHostedSessionModal.tsx



var CloseHostedSessionModal = function(param) {
    var isModalOpen = param.isModalOpen, onCloseModal = param.onCloseModal, onCloseHostedSession = param.onCloseHostedSession;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Modal, {
        isOpen: isModalOpen,
        title: t("session.close_modal.title"),
        description: t("session.close_modal.description"),
        onCloseModal: onCloseModal,
        icon: "warning",
        buttons: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                variant: "primary",
                onClick: onCloseModal,
                children: t("session.close_modal.cancel_button_label")
            }, "cancel-button"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                variant: "tertiary",
                onClick: onCloseHostedSession,
                children: t("session.close_modal.confirm_button_label")
            }, "confirm-button"), 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CloseHostedSessionModal/index.tsx


;// CONCATENATED MODULE: ./src/components/index.ts







// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(993);
// EXTERNAL MODULE: ./src/assets/logo.svg
var logo = __webpack_require__(8516);
var logo_default = /*#__PURE__*/__webpack_require__.n(logo);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
;// CONCATENATED MODULE: ./src/hooks/useSessionStorage/index.ts



var useSessionStorage = function(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var ref = (0,react.useState)(function() {
        if (false) {}
        try {
            var item = window.sessionStorage.getItem(key);
            return (0,lodash.defaultTo)(item, initialValue);
        } catch (error) {
            return initialValue;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to sessionStorage.
    var setValue = function(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = (0,_instanceof/* default */.Z)(value, Function) ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            if (true) {
                window.sessionStorage.setItem(key, valueToStore);
            }
        } catch (error) {
            console.warn("Error setting sessionStorage value: ", error);
        }
    };
    var removeItem = function() {
        if (false) {}
        window.sessionStorage.removeItem(key);
    };
    return {
        storedValue: storedValue,
        setValue: setValue,
        removeItem: removeItem
    };
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js
var ApolloProvider = __webpack_require__(3768);
;// CONCATENATED MODULE: ./src/types/generated/fragment-types.ts
/* eslint-disable */ var fragment_types_result = {
    "possibleTypes": {
        "Payload": [
            "ActionPayload",
            "ActivitiesPayload",
            "AddTrackPayload",
            "ApiCallPayload",
            "ApiCallsPayload",
            "BaselineInfoPayload",
            "CalculationResultsPayload",
            "CancelScheduledTracksPayload",
            "ChecklistPayload",
            "ClinicalNotePayload",
            "CompleteExtensionActivityPayload",
            "CreatePatientPayload",
            "ElementsPayload",
            "EmptyPayload",
            "EmrReportPayload",
            "EvaluateFormRulesPayload",
            "ExtensionActivityRecordPayload",
            "FormPayload",
            "FormResponsePayload",
            "FormsPayload",
            "HostedSessionActivitiesPayload",
            "HostedSessionPayload",
            "MarkMessageAsReadPayload",
            "MessagePayload",
            "OrchestrationFactsPayload",
            "OrchestrationFactsPromptPayload",
            "PathwayDataPointDefinitionsPayload",
            "PathwayPayload",
            "PathwaysPayload",
            "PatientDemographicsPayload",
            "PatientPathwaysPayload",
            "PatientPayload",
            "PatientsPayload",
            "PublishedPathwayDefinitionsPayload",
            "RetryApiCallPayload",
            "RetryWebhookCallPayload",
            "ScheduleTrackPayload",
            "ScheduledStepsPayload",
            "ScheduledTracksPayload",
            "SearchPatientsPayload",
            "StakeholdersPayload",
            "StartHostedActivitySessionPayload",
            "StartHostedPathwaySessionFromLinkPayload",
            "StartHostedPathwaySessionPayload",
            "StartPathwayPayload",
            "StopTrackPayload",
            "SubmitChecklistPayload",
            "SubmitFormResponsePayload",
            "TracksPayload",
            "UpdatePatientDemographicsQueryPayload",
            "UpdatePatientLanguagePayload",
            "UpdatePatientPayload",
            "UserPayload",
            "WebhookCallPayload",
            "WebhookCallsPayload"
        ]
    }
};
/* harmony default export */ var fragment_types = (fragment_types_result);

;// CONCATENATED MODULE: ./src/components/GraphqlWrapper.tsx






var onError = function(param) {
    var operation = param.operation, networkError = param.networkError;
    if (networkError) {
        esm_exports/* captureException */.Tb(networkError, {
            contexts: {
                graphql: {
                    operation: operation.operationName,
                    variables: JSON.stringify(operation.variables),
                    result: networkError.name === "ServerError" ? JSON.stringify(networkError.result) : undefined,
                    statusCode: networkError.name === "ServerError" ? JSON.stringify(networkError.statusCode) : undefined,
                    bodyText: networkError.name === "ServerParseError" ? JSON.stringify(networkError.bodyText) : undefined
                }
            }
        });
    }
};
var GraphqlWrapper = function(param) {
    var children = param.children;
    var client = createClient({
        httpUri: "https://api.development.awellhealth.com/orchestration/graphql",
        wsUri: "wss://api.development.awellhealth.com/orchestration/subscriptions",
        onNetworkError: onError,
        cacheConfig: {
            possibleTypes: fragment_types.possibleTypes
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider/* ApolloProvider */.e, {
        client: client,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/services/authentication/AuthenticationContext.ts

var AuthenticationContext_initialContext = {
    isAuthenticated: false
};
var AuthenticationContext = (0,react.createContext)(AuthenticationContext_initialContext);

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/services/authentication/AuthenticationProvider.tsx










var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
/*
 * Authentication is done in the following steps:
 * 1. On first load, we remove the accessToken from the sessionStorage. Why? Because sessions are short-termed and are expected to last for short timespans. So we remove the last token for any conflicts between the consecutive sessions.
 * 2. Then we create a new token using the NextJS API and save it as 'accessToken' in sessionStorage. While we create a new accessToken, no other operation is allowed. So loader is shown. 'tokenLoading' state locks the app from further execution.
 * 3. Once accessToken is generated, only then the children components of the app are rendered.
 */ var AuthenticationProvider = function(param) {
    var children = param.children;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useSessionStorage("accessToken", ""), accessToken = ref.storedValue, setAccessToken = ref.setValue, removeAccessToken = ref.removeItem;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(true), tokenLoading = ref1[0], setTokenLoading = ref1[1];
    var ref2 = (0,swr_dist/* default */.ZP)(router.query.sessionId ? "/api/session/".concat(router.query.sessionId) : null, fetcher), data = ref2.data, error = ref2.error;
    // @REVIEW - why do we remove the token rather than overwriting/replacing it
    (0,react.useEffect)(function() {
        // remove access token on first load
        removeAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.token) {
            setAccessToken(data === null || data === void 0 ? void 0 : data.token);
            setTokenLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : data.token
    ]);
    var authenticationContext = {
        isAuthenticated: accessToken !== "",
        accessToken: accessToken,
        error: error
    };
    if (router.isReady && !router.query.sessionId) {
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.NAVIGATION */.j.NAVIGATION,
            message: "Invalid URL",
            data: {
                url: router.asPath,
                sessionId: router.query.sessionId
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
            title: t("session.invalid_url")
        });
    }
    // Wait while token is being generated
    if (!router.isReady || tokenLoading) {
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.NAVIGATION */.j.NAVIGATION,
            message: "Preparing router and/or token",
            data: {
                url: router.asPath,
                sessionId: router.query.sessionId
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
            title: t("session.authentication_loading")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticationContext.Provider, {
        value: authenticationContext,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/services/authentication/useAuthentication.ts


var useAuthentication = function() {
    return (0,react.useContext)(AuthenticationContext);
};

;// CONCATENATED MODULE: ./src/services/authentication/index.ts



;// CONCATENATED MODULE: ./src/components/AuthGuard.tsx



var AuthGuard = function(param) {
    var children = param.children;
    var error = useAuthentication().error;
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "ERROR: ",
                JSON.stringify(error)
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
AuthGuard.displayName = "AuthGuard";

// EXTERNAL MODULE: ./src/components/NoSSR.tsx
var NoSSR = __webpack_require__(8264);
// EXTERNAL MODULE: ./src/components/ErrorBoundary/index.ts + 2 modules
var ErrorBoundary = __webpack_require__(3573);
;// CONCATENATED MODULE: ./src/layouts/HostedSessionLayout.tsx






var HostedSessionLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticationProvider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthGuard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GraphqlWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* NoSSRComponent */.R, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* ErrorBoundary */.S, {
                            children: children
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/layouts/index.tsx


// EXTERNAL MODULE: ./src/components/SuccessPage/successPage.module.css
var successPage_module = __webpack_require__(9354);
var successPage_module_default = /*#__PURE__*/__webpack_require__.n(successPage_module);
// EXTERNAL MODULE: ./src/assets/success.svg
var success = __webpack_require__(4608);
var success_default = /*#__PURE__*/__webpack_require__.n(success);
;// CONCATENATED MODULE: ./src/components/SuccessPage/SuccessPage.tsx





var SuccessPage = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (successPage_module_default()).success_page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (successPage_module_default()).success_icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (success_default()),
                    alt: "",
                    width: 64,
                    height: 64
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (successPage_module_default()).success_text,
                children: t("session.all_activities_completed")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SuccessPage/index.ts


// EXTERNAL MODULE: ./src/components/CancelPage/cancelPage.module.css
var cancelPage_module = __webpack_require__(9187);
var cancelPage_module_default = /*#__PURE__*/__webpack_require__.n(cancelPage_module);
// EXTERNAL MODULE: ./src/assets/cancel.svg
var cancel = __webpack_require__(6558);
var cancel_default = /*#__PURE__*/__webpack_require__.n(cancel);
;// CONCATENATED MODULE: ./src/components/CancelPage/CancelPage.tsx





var CancelPage = function(param) {
    var _message = param.message, message = _message === void 0 ? "session.session_canceled" : _message;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (cancelPage_module_default()).cancel_page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cancelPage_module_default()).cancel_icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (cancel_default()),
                    alt: "",
                    width: 64,
                    height: 64
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cancelPage_module_default()).cancel_text,
                children: t(message)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CancelPage/index.ts


// EXTERNAL MODULE: ./src/config/awell.ts
var awell = __webpack_require__(3248);
;// CONCATENATED MODULE: ./pages/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 



















// Handles Session URLs generated by Start Hosted Pathway/Activities Session mutation
// i.e. https://goto.awell.health/en?sessionId=e-Dmjxm3E5AW
var Home = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useHostedSession(), loading = ref.loading, session = ref.session, branding = ref.branding, error = ref.error, refetch = ref.refetch;
    var ref1 = useSessionStorage("accessToken", ""), removeAccessToken = ref1.removeItem;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), isCloseHostedSessionModalOpen = ref2[0], setIsCloseHostedSessionModalOpen = ref2[1];
    var redirectAfterSession = function(url) {
        // adding 2 second delay so users are aware of the redirection and we don't change the page abruptly
        setTimeout(function() {
            removeAccessToken();
            router.push(url);
        }, 2000);
        // add sentry breadcrumb if redirect takes more than 10 seconds
        setTimeout(function() {
            (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                category: addSentryBreadcrumb/* BreadcrumbCategory.SLOW_REDIRECT */.j.SLOW_REDIRECT,
                data: {
                    session: session,
                    message: "Redirect took at least 10 seconds"
                }
            });
        }, 10000);
        // add sentry breadcrumb if redirect takes more than 15 seconds
        setTimeout(function() {
            (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                category: addSentryBreadcrumb/* BreadcrumbCategory.SLOW_REDIRECT */.j.SLOW_REDIRECT,
                data: {
                    session: session,
                    message: "Redirect took at least 15 seconds"
                }
            });
        }, 15001);
    };
    var onOpenCloseHostedSessionModal = function() {
        setIsCloseHostedSessionModalOpen(true);
    };
    var onCloseHostedSessionModal = function() {
        setIsCloseHostedSessionModalOpen(false);
    };
    var onCloseHostedSession = function() {
        (0,ErrorReporter/* addSentryBreadcrumb */.b)({
            category: addSentryBreadcrumb/* BreadcrumbCategory.SESSION_CANCEL */.j.SESSION_CANCEL,
            data: session
        });
        var ref;
        router.push((ref = session === null || session === void 0 ? void 0 : session.cancel_url) !== null && ref !== void 0 ? ref : "https://awell.health");
    };
    var shouldRedirect = (session === null || session === void 0 ? void 0 : session.status) === HostedSessionStatus.Completed && !(0,lodash.isNil)(session === null || session === void 0 ? void 0 : session.success_url) || (session === null || session === void 0 ? void 0 : session.status) === HostedSessionStatus.Expired && !(0,lodash.isNil)(session === null || session === void 0 ? void 0 : session.cancel_url);
    (0,react.useEffect)(function() {
        if ((0,lodash.isNil)(session === null || session === void 0 ? void 0 : session.status)) {
            (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                category: addSentryBreadcrumb/* BreadcrumbCategory.GENERIC */.j.GENERIC,
                data: {
                    session: session,
                    message: "Session status is null"
                }
            });
            return;
        }
        if (false) {}
        switch(session === null || session === void 0 ? void 0 : session.status){
            case HostedSessionStatus.Completed:
                (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                    category: addSentryBreadcrumb/* BreadcrumbCategory.SESSION_COMPLETE */.j.SESSION_COMPLETE,
                    data: {
                        session: session
                    }
                });
                if (shouldRedirect) {
                    redirectAfterSession(session.success_url);
                }
                return;
            case HostedSessionStatus.Expired:
                (0,ErrorReporter/* addSentryBreadcrumb */.b)({
                    category: addSentryBreadcrumb/* BreadcrumbCategory.SESSION_EXPIRE */.j.SESSION_EXPIRE,
                    data: {
                        session: session
                    }
                });
                if (shouldRedirect) {
                    redirectAfterSession(session.cancel_url);
                }
                return;
            default:
                return;
        }
    }, [
        session
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("seo.loading_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("seo.loading_title")
                    }, "title")
                ]
            })
        });
    }
    if (session && (session === null || session === void 0 ? void 0 : session.status) !== HostedSessionStatus.Active) {
        var ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ThemeProvider, {
            accentColor: (ref3 = branding === null || branding === void 0 ? void 0 : branding.accent_color) !== null && ref3 !== void 0 ? ref3 : undefined,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.HostedPageLayout, {
                logo: (0,lodash.defaultTo)(branding === null || branding === void 0 ? void 0 : branding.logo_url, (logo_default())),
                onCloseHostedPage: onOpenCloseHostedSessionModal,
                hideCloseButton: (session.status === HostedSessionStatus.Completed || session.status === HostedSessionStatus.Expired) && shouldRedirect === false,
                children: [
                    shouldRedirect === false && session.status === HostedSessionStatus.Completed && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPage, {}),
                    shouldRedirect === false && session.status === HostedSessionStatus.Expired && /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelPage, {
                        message: "session.session_expired"
                    }),
                    shouldRedirect && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage/* LoadingPage */.h, {
                        title: t("session.redirecting_to_next_page")
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: (0,lodash.defaultTo)(branding === null || branding === void 0 ? void 0 : branding.hosted_page_title, t("seo.title"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("seo.title")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("seo.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ThemeProvider, {
                accentColor: (branding === null || branding === void 0 ? void 0 : branding.accent_color) || awell/* AWELL_BRAND_COLOR */.V,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.HostedPageLayout, {
                    logo: (0,lodash.defaultTo)(branding === null || branding === void 0 ? void 0 : branding.logo_url, (logo_default())),
                    onCloseHostedPage: onOpenCloseHostedSessionModal,
                    children: [
                        session && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesContainer, {}),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                            title: t("session.loading_error"),
                            onRetry: refetch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                            position: "bottom-right",
                            newestOnTop: true,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            autoClose: 12000,
                            hideProgressBar: true,
                            draggable: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseHostedSessionModal, {
                            isModalOpen: isCloseHostedSessionModalOpen,
                            onCloseHostedSession: onCloseHostedSession,
                            onCloseModal: onCloseHostedSessionModal
                        })
                    ]
                })
            })
        ]
    });
};
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HostedSessionLayout, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 3573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ ErrorBoundary_ErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(6567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/ErrorBoundary/error.module.css
var error_module = __webpack_require__(5898);
var error_module_default = /*#__PURE__*/__webpack_require__.n(error_module);
// EXTERNAL MODULE: ./src/components/ErrorPage/index.ts + 1 modules
var ErrorPage = __webpack_require__(6211);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary/reportErrorToSentry.ts

var reportErrorToSentry = function(error, errorInfo) {
    esm_exports/* withScope */.$e(function(scope) {
        scope.setContext("location", {
            location: window.location.pathname
        });
        esm_exports/* captureException */.Tb({
            error: error,
            errorInfo: errorInfo
        });
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary/ErrorBoundary.tsx
/* provided dependency */ var process = __webpack_require__(3454);











// https://reactjs.org/docs/error-boundaries.html
var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false,
            error: null,
            info: null
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, info) {
        this.setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: error,
                info: info
            });
        });
        reportErrorToSentry(error, info);
        var onError = this.props.onError;
        if (onError) onError(error);
    };
    _proto.render = function render() {
        var _state = this.state, hasError = _state.hasError, error = _state.error, info = _state.info;
        var children = this.props.children;
        var showStack =  false || process.env.NEXT_PUBLIC_AWELL_ENVIRONMENT === "staging";
        if (hasError) {
            if (showStack) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    style: {
                        whiteSpace: "pre-wrap"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorPage/* ErrorPage */.m, {
                        title: this.props.t("errors.app_error"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: error === null || error === void 0 ? void 0 : error.toString()
                            }),
                            showStack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: info === null || info === void 0 ? void 0 : info.componentStack
                            })
                        ]
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
                title: this.props.t("errors.app_error")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "error-boundary",
            className: (error_module_default()).error,
            style: this.props.style,
            children: children
        });
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var ErrorBoundary_ErrorBoundary = ((0,esm/* withTranslation */.Zh)()(ErrorBoundary));

;// CONCATENATED MODULE: ./src/components/ErrorBoundary/index.ts



/***/ }),

/***/ 6211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ ErrorPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/ErrorPage/errorPage.module.css
var errorPage_module = __webpack_require__(6455);
var errorPage_module_default = /*#__PURE__*/__webpack_require__.n(errorPage_module);
// EXTERNAL MODULE: ./node_modules/@awell-health/ui-library/dist/index.js
var dist = __webpack_require__(3066);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(632);
;// CONCATENATED MODULE: ./src/components/ErrorPage/ErrorPage.tsx




var ErrorPage = function(param) {
    var title = param.title, children = param.children, onRetry = param.onRetry;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (errorPage_module_default()).error_page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (errorPage_module_default()).error_page_content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (errorPage_module_default()).error_icon_container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            strokeWidth: "1.5",
                            stroke: "currentColor",
                            className: (errorPage_module_default()).error_icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (errorPage_module_default()).error_text,
                        children: title
                    }),
                    onRetry && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (errorPage_module_default()).try_again_btn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                            "data-cy": "tryAgainButton",
                            onClick: function() {
                                return onRetry();
                            },
                            children: t("session.try_again")
                        })
                    })
                ]
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ErrorPage/index.ts



/***/ }),

/***/ 6557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ LoadingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@awell-health/ui-library/dist/index.js
var dist = __webpack_require__(3066);
// EXTERNAL MODULE: ./src/components/LoadingPage/loadingPage.module.css
var loadingPage_module = __webpack_require__(3614);
var loadingPage_module_default = /*#__PURE__*/__webpack_require__.n(loadingPage_module);
;// CONCATENATED MODULE: ./src/components/LoadingPage/LoadingPage.tsx



var LoadingPage = function(param) {
    var title = param.title, hideLoader = param.hideLoader;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (loadingPage_module_default()).loading_page,
        children: [
            !hideLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HorizontalSpinner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (loadingPage_module_default()).loading_text,
                children: title
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/LoadingPage/index.ts



/***/ }),

/***/ 8264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ NoSSRComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var Wrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/**
 * This component disables SSR on all its children components.
 */ var NoSSRComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(Wrapper), {
    ssr: false
});


/***/ }),

/***/ 3248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AWELL_BRAND_COLOR; }
/* harmony export */ });
var AWELL_BRAND_COLOR = "#004ac2";


/***/ }),

/***/ 2041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ addSentryBreadcrumb; },
/* harmony export */   "j": function() { return /* binding */ BreadcrumbCategory; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4924);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4487);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);



var BreadcrumbCategory;
(function(BreadcrumbCategory) {
    BreadcrumbCategory["EVALUATE_FORM_RULES"] = "EVALUATE_FORM_RULES";
    BreadcrumbCategory["SUBMIT_FORM"] = "SUBMIT_FORM";
    BreadcrumbCategory["SESSION_COMPLETE"] = "SESSION_COMPLETE";
    BreadcrumbCategory["SESSION_EXPIRE"] = "SESSION_EXPIRE";
    BreadcrumbCategory["SESSION_CANCEL"] = "SESSION_CANCEL";
    BreadcrumbCategory["READ_MESSAGE"] = "READ_MESSAGE";
    BreadcrumbCategory["SUBMIT_CHECKLIST"] = "SUBMIT_CHECKLIST";
    BreadcrumbCategory["GENERIC"] = "GENERIC";
    BreadcrumbCategory["NAVIGATION"] = "NAVIGATION";
    BreadcrumbCategory["SLOW_REDIRECT"] = "SLOW_REDIRECT";
    BreadcrumbCategory["HOSTED_PAGES_LINK_ERROR"] = "HOSTED_PAGES_LINK_ERROR";
    BreadcrumbCategory["HOSTED_ACTIVITY_ERROR"] = "HOSTED_ACTIVITY_ERROR";
})(BreadcrumbCategory || (BreadcrumbCategory = {}));
var _obj;
var SentryBreadcrumbMessageDictionary = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.EVALUATE_FORM_RULES, "Evaluating form rules"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SUBMIT_FORM, "Submitting form"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SESSION_COMPLETE, "Session completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SESSION_CANCEL, "Session cancelled"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SESSION_EXPIRE, "Session expired"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.READ_MESSAGE, "Reading message"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SUBMIT_CHECKLIST, "Submitting checklist"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.GENERIC, "Generic event"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.NAVIGATION, "Navigation"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.SLOW_REDIRECT, "Slow redirect at session end"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.HOSTED_PAGES_LINK_ERROR, "Error with hosted pages link"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BreadcrumbCategory.HOSTED_ACTIVITY_ERROR, "Error with hosted activity link"), _obj);
var addSentryBreadcrumb = function(param) {
    var category = param.category, data = param.data;
    (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .addBreadcrumb */ .n_)({
        message: (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(SentryBreadcrumbMessageDictionary, category, // default:
        SentryBreadcrumbMessageDictionary[BreadcrumbCategory.GENERIC]),
        category: category,
        data: {
            context: JSON.stringify(data)
        }
    });
};


/***/ }),

/***/ 8644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ addSentryBreadcrumb/* addSentryBreadcrumb */.b; },
  "g": function() { return /* reexport */ masker; }
});

// EXTERNAL MODULE: ./src/services/ErrorReporter/addSentryBreadcrumb.ts
var addSentryBreadcrumb = __webpack_require__(2041);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/services/ErrorReporter/masker.ts
/**
 * Masker function to mask sensitive data from form related breadcrumbs. This assumes
 * that the object(s) have a field called value that needs to be masked.
 * @param value this is the value to be masked, can be an object or an array of
 * objects with a value field
 * @returns the masked object or array of objects
 */ 
var masker = function(value) {
    if (Array.isArray(value)) {
        return value.map(masker);
    }
    if (typeof value === "object" && value !== null && value !== undefined) {
        return Object.fromEntries(Object.entries(value).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], _$value = _param[1];
            if (key !== "value") {
                return [
                    key,
                    _$value
                ];
            }
            return [
                key,
                typeof _$value === "string" || typeof _$value === "number" ? "*".repeat(_$value.toString().length) : masker(_$value), 
            ];
        }));
    }
    return value;
};

;// CONCATENATED MODULE: ./src/services/ErrorReporter/index.ts




/***/ }),

/***/ 9187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cancel_page":"cancelPage_cancel_page__i_2nc","cancel_icon":"cancelPage_cancel_icon__8Zr4F","cancel_text":"cancelPage_cancel_text__w0_xb"};

/***/ }),

/***/ 5898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__RbXeS"};

/***/ }),

/***/ 6455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error_page":"errorPage_error_page__To78P","error_icon_container":"errorPage_error_icon_container__r4KgY","error_icon":"errorPage_error_icon__MQrjO","error_text":"errorPage_error_text__M_TI3","error_page_content":"errorPage_error_page_content__WGaQo","try_again_btn":"errorPage_try_again_btn__Fs2V4"};

/***/ }),

/***/ 7640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"remoteSingleSelectAction_container__iMSj6","selectContainer":"remoteSingleSelectAction_selectContainer__VjCDP","buttonContainer":"remoteSingleSelectAction_buttonContainer__Q2krW","error":"remoteSingleSelectAction_error__za59X"};

/***/ }),

/***/ 1397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"embeddedSigning_wrapper__5zcQi","flex-full":"embeddedSigning_flex-full__UzV2e","iframe-loaded":"embeddedSigning_iframe-loaded__E_8vP","iframe-loading":"embeddedSigning_iframe-loading__RuVf_"};

/***/ }),

/***/ 4612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"completeFlowAction_container__kpqbH"};

/***/ }),

/***/ 3614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading_page":"loadingPage_loading_page__8JVhz","loading_text":"loadingPage_loading_text__Gjs_i"};

/***/ }),

/***/ 9354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"success_page":"successPage_success_page__Ztjej","success_icon":"successPage_success_icon__m4YTX","success_text":"successPage_success_text__TZrpz"};

/***/ }),

/***/ 6558:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMzIiIGZpbGw9IiNGOUQ1RDciLz4KPHBhdGggZD0iTTIyIDQyTDQyIDIyTTIyIDIyTDQyIDQyIiBzdHJva2U9IiNFMTJEMzkiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 4311:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIgogICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgPHBhdGggZD0iTTQuMjIyMzkgMTkuNzc4QzQuNjg2MjYgMjAuMjQyNSA1LjIzNzM2IDIwLjYxMDggNS44NDQwMSAyMC44NjE3QzYuNDUwNjYgMjEuMTEyNiA3LjEwMDkgMjEuMjQxMSA3Ljc1NzM5IDIxLjI0QzguNDE0MDIgMjEuMjQxMSA5LjA2NDQxIDIxLjExMjUgOS42NzEyMiAyMC44NjE3QzEwLjI3OCAyMC42MTA4IDEwLjgyOTMgMjAuMjQyNSAxMS4yOTM0IDE5Ljc3OEwxNC4xMjE0IDE2Ljk0OUwxMi43MDc0IDE1LjUzNUw5Ljg3OTM5IDE4LjM2NEM5LjMxNTg2IDE4LjkyNSA4LjU1MzA2IDE5LjIzOTkgNy43NTc4OSAxOS4yMzk5QzYuOTYyNzIgMTkuMjM5OSA2LjE5OTkyIDE4LjkyNSA1LjYzNjM5IDE4LjM2NEM1LjA3NDg5IDE3LjgwMDcgNC43NTk2IDE3LjAzNzggNC43NTk2IDE2LjI0MjVDNC43NTk2IDE1LjQ0NzEgNS4wNzQ4OSAxNC42ODQyIDUuNjM2MzkgMTQuMTIxTDguNDY1MzkgMTEuMjkzTDcuMDUxMzkgOS44Nzg5Nkw0LjIyMjM5IDEyLjcwN0MzLjI4NjIgMTMuNjQ1NCAyLjc2MDQ0IDE0LjkxNjkgMi43NjA0NCAxNi4yNDI1QzIuNzYwNDQgMTcuNTY4IDMuMjg2MiAxOC44Mzk1IDQuMjIyMzkgMTkuNzc4Wk0xOS43Nzg0IDExLjI5M0MyMC43MTQxIDEwLjM1NDIgMjEuMjM5NSA5LjA4Mjg4IDIxLjIzOTUgNy43NTc0NkMyMS4yMzk1IDYuNDMyMDQgMjAuNzE0MSA1LjE2MDY4IDE5Ljc3ODQgNC4yMjE5NkMxOC44Mzk5IDMuMjg1NzcgMTcuNTY4NSAyLjc2MDAxIDE2LjI0MjkgMi43NjAwMUMxNC45MTczIDIuNzYwMDEgMTMuNjQ1OCAzLjI4NTc3IDEyLjcwNzQgNC4yMjE5Nkw5Ljg3OTM5IDcuMDUwOTZMMTEuMjkzNCA4LjQ2NDk2TDE0LjEyMTQgNS42MzU5NkMxNC42ODQ5IDUuMDc0OTUgMTUuNDQ3NyA0Ljc1OTk5IDE2LjI0MjkgNC43NTk5OUMxNy4wMzgxIDQuNzU5OTkgMTcuODAwOSA1LjA3NDk1IDE4LjM2NDQgNS42MzU5NkMxOC45MjU5IDYuMTk5MjMgMTkuMjQxMiA2Ljk2MjEzIDE5LjI0MTIgNy43NTc0NkMxOS4yNDEyIDguNTUyNzkgMTguOTI1OSA5LjMxNTY5IDE4LjM2NDQgOS44Nzg5NkwxNS41MzU0IDEyLjcwN0wxNi45NDk0IDE0LjEyMUwxOS43Nzg0IDExLjI5M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgICAgIDxwYXRoIGQ9Ik04LjQ2NDM4IDE2Ljk1TDcuMDQ5MzggMTUuNTM2TDE1LjUzNjQgNy4wNDk5NkwxNi45NTA0IDguNDY0OTZMOC40NjQzOCAxNi45NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4="

/***/ }),

/***/ 8516:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 4608:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMzIiIGZpbGw9IiNFM0ZDRUYiLz4KPHBhdGggZD0iTTE5LjUgMzMuMjVMMjkuNSA0My4yNUw0NC41IDIwLjc1IiBzdHJva2U9IiMzNkIzN0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [210,662,891,595,618,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);